export interface VocabWord {
  wordId: number;
  setId: number;
  setName: string;
  swedish: string;
  english: string;
  pronunciation: string;
  sentence?: string;
  sentenceTranslation?: string;
}

export const swedishVocabulary: VocabWord[] = [
  {
    "wordId": 1,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Ja",
    "english": "Yes",
    "pronunciation": "Yaa",
    "sentence": "Ja, jag förstår.",
    "sentenceTranslation": "Yes, I understand."
  },
  {
    "wordId": 2,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Nej",
    "english": "No",
    "pronunciation": "Nay",
    "sentence": "Nej, jag vet inte.",
    "sentenceTranslation": "No, I do not know."
  },
  {
    "wordId": 3,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Hej",
    "english": "Hello",
    "pronunciation": "Hay",
    "sentence": "Hej, hur mår du?",
    "sentenceTranslation": "Hello, how are you?"
  },
  {
    "wordId": 4,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Tack",
    "english": "Thanks",
    "pronunciation": "Tock",
    "sentence": "Tack för hjälpen.",
    "sentenceTranslation": "Thanks for the help."
  },
  {
    "wordId": 5,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Förlåt",
    "english": "Sorry",
    "pronunciation": "Fur-loht",
    "sentence": "Förlåt, jag är sen.",
    "sentenceTranslation": "Sorry, I am late."
  },
  {
    "wordId": 6,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Bra",
    "english": "Good",
    "pronunciation": "Braa",
    "sentence": "Bra, vi ses imorgon.",
    "sentenceTranslation": "Good, see you tomorrow."
  },
  {
    "wordId": 7,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Dålig",
    "english": "Bad",
    "pronunciation": "Doh-lig",
    "sentence": "Dålig mat är inte god.",
    "sentenceTranslation": "Bad food is not tasty."
  },
  {
    "wordId": 8,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Hjälp",
    "english": "Help",
    "pronunciation": "Yelp",
    "sentence": "Hjälp mig, snälla.",
    "sentenceTranslation": "Help me, please."
  },
  {
    "wordId": 9,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Nu",
    "english": "Now",
    "pronunciation": "Noo",
    "sentence": "Nu måste vi gå.",
    "sentenceTranslation": "Now we must go."
  },
  {
    "wordId": 10,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Här",
    "english": "Here",
    "pronunciation": "Hair",
    "sentence": "Här bor jag.",
    "sentenceTranslation": "Here I live."
  },
  {
    "wordId": 11,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Där",
    "english": "There",
    "pronunciation": "Dair",
    "sentence": "Där är min bil.",
    "sentenceTranslation": "There is my car."
  },
  {
    "wordId": 12,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Vem",
    "english": "Who",
    "pronunciation": "Vem",
    "sentence": "Vem är du?",
    "sentenceTranslation": "Who are you?"
  },
  {
    "wordId": 13,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Vad",
    "english": "What",
    "pronunciation": "Vadd",
    "sentence": "Vad gör du?",
    "sentenceTranslation": "What are you doing?"
  },
  {
    "wordId": 14,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Var",
    "english": "Where",
    "pronunciation": "Varr",
    "sentence": "Var är du?",
    "sentenceTranslation": "Where are you?"
  },
  {
    "wordId": 15,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "När",
    "english": "When",
    "pronunciation": "Nair",
    "sentence": "När kommer du?",
    "sentenceTranslation": "When are you coming?"
  },
  {
    "wordId": 16,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Varför",
    "english": "Why",
    "pronunciation": "Var-fur",
    "sentence": "Varför gråter du?",
    "sentenceTranslation": "Why are you crying?"
  },
  {
    "wordId": 17,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Hur",
    "english": "How",
    "pronunciation": "Hoor",
    "sentence": "Hur mår du?",
    "sentenceTranslation": "How are you?"
  },
  {
    "wordId": 18,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Och",
    "english": "And",
    "pronunciation": "Ok",
    "sentence": "Och vad gör du?",
    "sentenceTranslation": "And what are you doing?"
  },
  {
    "wordId": 19,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Men",
    "english": "But",
    "pronunciation": "Men",
    "sentence": "Men jag vill inte.",
    "sentenceTranslation": "But I do not want to."
  },
  {
    "wordId": 20,
    "setId": 1,
    "setName": "1. Absolute Essentials",
    "swedish": "Eller",
    "english": "Or",
    "pronunciation": "El-ler",
    "sentence": "Eller vill du ha te?",
    "sentenceTranslation": "Or do you want tea?"
  },
  {
    "wordId": 1,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Jag",
    "english": "I",
    "pronunciation": "Yaag",
    "sentence": "Jag talar svenska.",
    "sentenceTranslation": "I speak Swedish."
  },
  {
    "wordId": 2,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Du",
    "english": "You",
    "pronunciation": "Doo",
    "sentence": "Du är snäll.",
    "sentenceTranslation": "You are kind."
  },
  {
    "wordId": 3,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Han",
    "english": "He",
    "pronunciation": "Hahn",
    "sentence": "Han läser en bok.",
    "sentenceTranslation": "He is reading a book."
  },
  {
    "wordId": 4,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Hon",
    "english": "She",
    "pronunciation": "Hoon",
    "sentence": "Hon är min vän.",
    "sentenceTranslation": "She is my friend."
  },
  {
    "wordId": 5,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Det",
    "english": "It",
    "pronunciation": "Deh",
    "sentence": "Det är kallt.",
    "sentenceTranslation": "It is cold."
  },
  {
    "wordId": 6,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Vi",
    "english": "We",
    "pronunciation": "Vee",
    "sentence": "Vi ses imorgon.",
    "sentenceTranslation": "We will see each other tomorrow."
  },
  {
    "wordId": 7,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Ni",
    "english": "You (plural)",
    "pronunciation": "Nee",
    "sentence": "Ni kan sitta här.",
    "sentenceTranslation": "You can sit here."
  },
  {
    "wordId": 8,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "De",
    "english": "They",
    "pronunciation": "Dom",
    "sentence": "De bor i Stockholm.",
    "sentenceTranslation": "They live in Stockholm."
  },
  {
    "wordId": 9,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Min",
    "english": "My",
    "pronunciation": "Min",
    "sentence": "Min katt är vit.",
    "sentenceTranslation": "My cat is white."
  },
  {
    "wordId": 10,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Din",
    "english": "Your",
    "pronunciation": "Din",
    "sentence": "Din hund är söt.",
    "sentenceTranslation": "Your dog is cute."
  },
  {
    "wordId": 11,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Man",
    "english": "Man",
    "pronunciation": "Mann",
    "sentence": "Man kan köpa glass här.",
    "sentenceTranslation": "One can buy ice cream here."
  },
  {
    "wordId": 12,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Kvinna",
    "english": "Woman",
    "pronunciation": "Kvin-nah",
    "sentence": "En Kvinna läser en bok.",
    "sentenceTranslation": "A woman is reading a book."
  },
  {
    "wordId": 13,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Barn",
    "english": "Child",
    "pronunciation": "Baarn",
    "sentence": "Ett Barn leker ute.",
    "sentenceTranslation": "A child is playing outside."
  },
  {
    "wordId": 14,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Pojke",
    "english": "Boy",
    "pronunciation": "Poy-keh",
    "sentence": "En Pojke springer fort.",
    "sentenceTranslation": "A boy runs fast."
  },
  {
    "wordId": 15,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Flicka",
    "english": "Girl",
    "pronunciation": "Flik-ka",
    "sentence": "En Flicka ritar nu.",
    "sentenceTranslation": "A girl is drawing now."
  },
  {
    "wordId": 16,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Vän",
    "english": "Friend",
    "pronunciation": "Ven",
    "sentence": "Vän är ett fint ord.",
    "sentenceTranslation": "Friend is a nice word."
  },
  {
    "wordId": 17,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Familj",
    "english": "Family",
    "pronunciation": "Fah-mily",
    "sentence": "Familj betyder allt för mig.",
    "sentenceTranslation": "Family means everything to me."
  },
  {
    "wordId": 18,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Namn",
    "english": "Name",
    "pronunciation": "Namn",
    "sentence": "Namn är svåra att minnas.",
    "sentenceTranslation": "Names are hard to remember."
  },
  {
    "wordId": 19,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Människa",
    "english": "Human",
    "pronunciation": "Men-nish-ah",
    "sentence": "Människa är ett annat ord för person.",
    "sentenceTranslation": "Human is another word for person."
  },
  {
    "wordId": 20,
    "setId": 2,
    "setName": "2. Pronouns & People",
    "swedish": "Folk",
    "english": "People",
    "pronunciation": "Folk",
    "sentence": "Folk tycker om att fika.",
    "sentenceTranslation": "People like to have coffee."
  },
  {
    "wordId": 1,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Är",
    "english": "Am/Is/Are",
    "pronunciation": "Air",
    "sentence": "Är du redo för testet?",
    "sentenceTranslation": "Are you ready for the test?"
  },
  {
    "wordId": 2,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Har",
    "english": "Have",
    "pronunciation": "Har",
    "sentence": "Har du en stor familj?",
    "sentenceTranslation": "Do you have a large family?"
  },
  {
    "wordId": 3,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Gör",
    "english": "Do",
    "pronunciation": "Yur",
    "sentence": "Gör du läxan varje dag?",
    "sentenceTranslation": "Do you do the homework every day?"
  },
  {
    "wordId": 4,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Kan",
    "english": "Can",
    "pronunciation": "Kann",
    "sentence": "Kan du prata lite långsammare?",
    "sentenceTranslation": "Can you speak a little slower?"
  },
  {
    "wordId": 5,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Vill",
    "english": "Want",
    "pronunciation": "Vill",
    "sentence": "Vill du dricka kaffe?",
    "sentenceTranslation": "Do you want to drink coffee?"
  },
  {
    "wordId": 6,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Ska",
    "english": "Will/Shall",
    "pronunciation": "Skah",
    "sentence": "Ska vi äta middag nu?",
    "sentenceTranslation": "Shall we eat dinner now?"
  },
  {
    "wordId": 7,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Måste",
    "english": "Must",
    "pronunciation": "Moss-teh",
    "sentence": "Måste du arbeta i helgen?",
    "sentenceTranslation": "Do you have to work this weekend?"
  },
  {
    "wordId": 8,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Går",
    "english": "Go/Walk",
    "pronunciation": "Gohr",
    "sentence": "Går du till skolan varje dag?",
    "sentenceTranslation": "Do you walk to school every day?"
  },
  {
    "wordId": 9,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Kommer",
    "english": "Come",
    "pronunciation": "Kom-mer",
    "sentence": "Kommer du till min fest?",
    "sentenceTranslation": "Are you coming to my party?"
  },
  {
    "wordId": 10,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Ser",
    "english": "See",
    "pronunciation": "Seer",
    "sentence": "Ser du den lilla fågeln?",
    "sentenceTranslation": "Do you see the small bird?"
  },
  {
    "wordId": 11,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Hör",
    "english": "Hear",
    "pronunciation": "Hur",
    "sentence": "Hör du musiken där borta?",
    "sentenceTranslation": "Do you hear the music over there?"
  },
  {
    "wordId": 12,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Säger",
    "english": "Say",
    "pronunciation": "Say-yer",
    "sentence": "Säger du att det är sant?",
    "sentenceTranslation": "Are you saying that it is true?"
  },
  {
    "wordId": 13,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Pratar",
    "english": "Speak",
    "pronunciation": "Pra-tar",
    "sentence": "Pratar du svenska med dem?",
    "sentenceTranslation": "Do you speak Swedish with them?"
  },
  {
    "wordId": 14,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Vet",
    "english": "Know",
    "pronunciation": "Veht",
    "sentence": "Vet du vad klockan är?",
    "sentenceTranslation": "Do you know what time it is?"
  },
  {
    "wordId": 15,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Förstår",
    "english": "Understand",
    "pronunciation": "Fur-stohr",
    "sentence": "Förstår du vad jag menar?",
    "sentenceTranslation": "Do you understand what I mean?"
  },
  {
    "wordId": 16,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Äter",
    "english": "Eat",
    "pronunciation": "Eh-ter",
    "sentence": "Äter du frukost varje morgon?",
    "sentenceTranslation": "Do you eat breakfast every morning?"
  },
  {
    "wordId": 17,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Dricker",
    "english": "Drink",
    "pronunciation": "Drik-ker",
    "sentence": "Dricker du te eller kaffe?",
    "sentenceTranslation": "Do you drink tea or coffee?"
  },
  {
    "wordId": 18,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Sover",
    "english": "Sleep",
    "pronunciation": "Soh-ver",
    "sentence": "Sover du bra på natten?",
    "sentenceTranslation": "Do you sleep well at night?"
  },
  {
    "wordId": 19,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Jobbar",
    "english": "Work",
    "pronunciation": "Yob-bar",
    "sentence": "Jobbar du på ett sjukhus?",
    "sentenceTranslation": "Do you work at a hospital?"
  },
  {
    "wordId": 20,
    "setId": 3,
    "setName": "3. Core Verbs",
    "swedish": "Älskar",
    "english": "Love",
    "pronunciation": "El-skar",
    "sentence": "Älskar du att bo här?",
    "sentenceTranslation": "Do you love living here?"
  },
  {
    "wordId": 1,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Noll",
    "english": "Zero",
    "pronunciation": "Noll",
    "sentence": "Noll är ett lågt tal.",
    "sentenceTranslation": "Zero is a low number."
  },
  {
    "wordId": 2,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "En/Ett",
    "english": "One",
    "pronunciation": "En / Ett",
    "sentence": "En/Ett är artiklar i svenskan.",
    "sentenceTranslation": "En/Ett are articles in Swedish."
  },
  {
    "wordId": 3,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Två",
    "english": "Two",
    "pronunciation": "Tvoh",
    "sentence": "Två katter leker på golvet.",
    "sentenceTranslation": "Two cats are playing on the floor."
  },
  {
    "wordId": 4,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Tre",
    "english": "Three",
    "pronunciation": "Tree",
    "sentence": "Tre personer sitter på bänken.",
    "sentenceTranslation": "Three people are sitting on the bench."
  },
  {
    "wordId": 5,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Fyra",
    "english": "Four",
    "pronunciation": "Fee-rah",
    "sentence": "Fyra koppar står på bordet.",
    "sentenceTranslation": "Four cups are standing on the table."
  },
  {
    "wordId": 6,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Fem",
    "english": "Five",
    "pronunciation": "Fem",
    "sentence": "Fem fingrar finns på min hand.",
    "sentenceTranslation": "Five fingers are on my hand."
  },
  {
    "wordId": 7,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Sex",
    "english": "Six",
    "pronunciation": "Sex",
    "sentence": "Sex personer sitter i bilen.",
    "sentenceTranslation": "Six people are sitting in the car."
  },
  {
    "wordId": 8,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Sju",
    "english": "Seven",
    "pronunciation": "Shoo",
    "sentence": "Sju barn leker ute.",
    "sentenceTranslation": "Seven children are playing outside."
  },
  {
    "wordId": 9,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Åtta",
    "english": "Eight",
    "pronunciation": "Ot-tah",
    "sentence": "Åtta bilar står på gatan.",
    "sentenceTranslation": "Eight cars are standing on the street."
  },
  {
    "wordId": 10,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Nio",
    "english": "Nine",
    "pronunciation": "Nee-oh",
    "sentence": "Nio fåglar flyger i luften.",
    "sentenceTranslation": "Nine birds are flying in the air."
  },
  {
    "wordId": 11,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Tio",
    "english": "Ten",
    "pronunciation": "Tee-oh",
    "sentence": "Tio barn leker.",
    "sentenceTranslation": "Ten children are playing."
  },
  {
    "wordId": 12,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Elva",
    "english": "Eleven",
    "pronunciation": "El-vah",
    "sentence": "Elva katter sover.",
    "sentenceTranslation": "Eleven cats are sleeping."
  },
  {
    "wordId": 13,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Tolv",
    "english": "Twelve",
    "pronunciation": "Tolv",
    "sentence": "Tolv timmar går fort.",
    "sentenceTranslation": "Twelve hours go fast."
  },
  {
    "wordId": 14,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Tretton",
    "english": "Thirteen",
    "pronunciation": "Tret-ton",
    "sentence": "Tretton fåglar sjunger.",
    "sentenceTranslation": "Thirteen birds are singing."
  },
  {
    "wordId": 15,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Fjorton",
    "english": "Fourteen",
    "pronunciation": "Fyoor-ton",
    "sentence": "Fjorton hundar springer.",
    "sentenceTranslation": "Fourteen dogs are running."
  },
  {
    "wordId": 16,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Femton",
    "english": "Fifteen",
    "pronunciation": "Fem-ton",
    "sentence": "Femton äpplen är röda.",
    "sentenceTranslation": "Fifteen apples are red."
  },
  {
    "wordId": 17,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Sexton",
    "english": "Sixteen",
    "pronunciation": "Sex-ton",
    "sentence": "Sexton bilar är här.",
    "sentenceTranslation": "Sixteen cars are here."
  },
  {
    "wordId": 18,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Sjutton",
    "english": "Seventeen",
    "pronunciation": "Shoo-ton",
    "sentence": "Sjutton flickor dansar.",
    "sentenceTranslation": "Seventeen girls are dancing."
  },
  {
    "wordId": 19,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Arton",
    "english": "Eighteen",
    "pronunciation": "Arr-ton",
    "sentence": "Arton pojkar spelar.",
    "sentenceTranslation": "Eighteen boys are playing."
  },
  {
    "wordId": 20,
    "setId": 4,
    "setName": "4. Numbers 0-20",
    "swedish": "Nitton",
    "english": "Nineteen",
    "pronunciation": "Nit-ton",
    "sentence": "Nitton böcker ligger här.",
    "sentenceTranslation": "Nineteen books are lying here."
  },
  {
    "wordId": 1,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Stor",
    "english": "Big",
    "pronunciation": "Stoor",
    "sentence": "Stor är min hund.",
    "sentenceTranslation": "Big is my dog."
  },
  {
    "wordId": 2,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Liten",
    "english": "Small",
    "pronunciation": "Lee-ten",
    "sentence": "Liten är min katt.",
    "sentenceTranslation": "Small is my cat."
  },
  {
    "wordId": 3,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Ny",
    "english": "New",
    "pronunciation": "Nee",
    "sentence": "Ny är min mobil.",
    "sentenceTranslation": "New is my mobile phone."
  },
  {
    "wordId": 4,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Gammal",
    "english": "Old",
    "pronunciation": "Gam-mal",
    "sentence": "Gammal är min bil.",
    "sentenceTranslation": "Old is my car."
  },
  {
    "wordId": 5,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Varm",
    "english": "Hot",
    "pronunciation": "Varr-m",
    "sentence": "Varm är denna sommar.",
    "sentenceTranslation": "Warm is this summer."
  },
  {
    "wordId": 6,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Kall",
    "english": "Cold",
    "pronunciation": "Kall",
    "sentence": "Kall är denna vinter.",
    "sentenceTranslation": "Cold is this winter."
  },
  {
    "wordId": 7,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Lång",
    "english": "Long",
    "pronunciation": "Long",
    "sentence": "Lång är denna gata.",
    "sentenceTranslation": "Long is this street."
  },
  {
    "wordId": 8,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Kort",
    "english": "Short",
    "pronunciation": "Koort",
    "sentence": "Kort är hans jacka.",
    "sentenceTranslation": "Short is his jacket."
  },
  {
    "wordId": 9,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Lätt",
    "english": "Easy/Light",
    "pronunciation": "Lett",
    "sentence": "Lätt är denna bok.",
    "sentenceTranslation": "Easy is this book."
  },
  {
    "wordId": 10,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Svår",
    "english": "Hard/Difficult",
    "pronunciation": "Svohr",
    "sentence": "Svår är denna läxa.",
    "sentenceTranslation": "Difficult is this homework."
  },
  {
    "wordId": 11,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Billig",
    "english": "Cheap",
    "pronunciation": "Bil-lig",
    "sentence": "Billig är denna mat.",
    "sentenceTranslation": "Cheap is this food."
  },
  {
    "wordId": 12,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Dyr",
    "english": "Expensive",
    "pronunciation": "Dyr",
    "sentence": "Dyr är denna klocka.",
    "sentenceTranslation": "Expensive is this watch."
  },
  {
    "wordId": 13,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Ung",
    "english": "Young",
    "pronunciation": "Ung",
    "sentence": "Ung är denna tjej.",
    "sentenceTranslation": "Young is this girl."
  },
  {
    "wordId": 14,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Snabb",
    "english": "Fast",
    "pronunciation": "Snab",
    "sentence": "Snabb är denna bil.",
    "sentenceTranslation": "Fast is this car."
  },
  {
    "wordId": 15,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Långsam",
    "english": "Slow",
    "pronunciation": "Long-sahm",
    "sentence": "Långsam är denna buss.",
    "sentenceTranslation": "Slow is this bus."
  },
  {
    "wordId": 16,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Tidig",
    "english": "Early",
    "pronunciation": "Tee-dig",
    "sentence": "Tidig är denna morgon.",
    "sentenceTranslation": "Early is this morning."
  },
  {
    "wordId": 17,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Sen",
    "english": "Late",
    "pronunciation": "Sehn",
    "sentence": "Sen är denna kväll.",
    "sentenceTranslation": "Late is this evening."
  },
  {
    "wordId": 18,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Vacker",
    "english": "Beautiful",
    "pronunciation": "Vak-ker",
    "sentence": "Vacker är denna blomma.",
    "sentenceTranslation": "Beautiful is this flower."
  },
  {
    "wordId": 19,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Ful",
    "english": "Ugly",
    "pronunciation": "Fool",
    "sentence": "Ful är denna färg.",
    "sentenceTranslation": "Ugly is this color."
  },
  {
    "wordId": 20,
    "setId": 5,
    "setName": "5. Common Adjectives",
    "swedish": "Viktig",
    "english": "Important",
    "pronunciation": "Vik-tig",
    "sentence": "Viktig är denna regel.",
    "sentenceTranslation": "Important is this rule."
  },
  {
    "wordId": 1,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Mat",
    "english": "Food",
    "pronunciation": "Maat",
    "sentence": "Mat finns på bordet.",
    "sentenceTranslation": "Food is on the table."
  },
  {
    "wordId": 2,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Vatten",
    "english": "Water",
    "pronunciation": "Vat-ten",
    "sentence": "Vatten är gott.",
    "sentenceTranslation": "Water is good."
  },
  {
    "wordId": 3,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Bröd",
    "english": "Bread",
    "pronunciation": "Brurd",
    "sentence": "Bröd ligger på bordet.",
    "sentenceTranslation": "Bread is lying on the table."
  },
  {
    "wordId": 4,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Kaffe",
    "english": "Coffee",
    "pronunciation": "Kaf-feh",
    "sentence": "Kaffe är varmt.",
    "sentenceTranslation": "Coffee is hot."
  },
  {
    "wordId": 5,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Te",
    "english": "Tea",
    "pronunciation": "Teh",
    "sentence": "Te dricker jag.",
    "sentenceTranslation": "Tea I drink."
  },
  {
    "wordId": 6,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Mjölk",
    "english": "Milk",
    "pronunciation": "Myoolk",
    "sentence": "Mjölk är kallt.",
    "sentenceTranslation": "Milk is cold."
  },
  {
    "wordId": 7,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Kött",
    "english": "Meat",
    "pronunciation": "Shut",
    "sentence": "Kött kommer från djur.",
    "sentenceTranslation": "Meat comes from animals."
  },
  {
    "wordId": 8,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Fisk",
    "english": "Fish",
    "pronunciation": "Fisk",
    "sentence": "Fisk är gott.",
    "sentenceTranslation": "Fish is delicious."
  },
  {
    "wordId": 9,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Kyckling",
    "english": "Chicken",
    "pronunciation": "Shyk-ling",
    "sentence": "Kyckling är en fågel.",
    "sentenceTranslation": "Chicken is a bird."
  },
  {
    "wordId": 10,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Ägg",
    "english": "Egg",
    "pronunciation": "Eg",
    "sentence": "Ägg är nyttigt.",
    "sentenceTranslation": "Eggs are healthy."
  },
  {
    "wordId": 11,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Ost",
    "english": "Cheese",
    "pronunciation": "Oost",
    "sentence": "Ost smakar bäst på mackan.",
    "sentenceTranslation": "Cheese tastes best on the sandwich."
  },
  {
    "wordId": 12,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Frukt",
    "english": "Fruit",
    "pronunciation": "Frukt",
    "sentence": "Frukt är gott.",
    "sentenceTranslation": "Fruit is delicious."
  },
  {
    "wordId": 13,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Grönsaker",
    "english": "Vegetables",
    "pronunciation": "Gruhn-sah-ker",
    "sentence": "Grönsaker är bra för hälsan.",
    "sentenceTranslation": "Vegetables are good for your health."
  },
  {
    "wordId": 14,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Socker",
    "english": "Sugar",
    "pronunciation": "Sock-er",
    "sentence": "Socker gör teet sött.",
    "sentenceTranslation": "Sugar makes the tea sweet."
  },
  {
    "wordId": 15,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Salt",
    "english": "Salt",
    "pronunciation": "Salt",
    "sentence": "Salt ger god smak.",
    "sentenceTranslation": "Salt gives good taste."
  },
  {
    "wordId": 16,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Frukost",
    "english": "Breakfast",
    "pronunciation": "Froo-kost",
    "sentence": "Frukost serveras klockan åtta.",
    "sentenceTranslation": "Breakfast is served at eight o'clock."
  },
  {
    "wordId": 17,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Lunch",
    "english": "Lunch",
    "pronunciation": "Lunch",
    "sentence": "Lunch äter jag klockan tolv.",
    "sentenceTranslation": "Lunch I eat at twelve o'clock."
  },
  {
    "wordId": 18,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Middag",
    "english": "Dinner",
    "pronunciation": "Mid-daag",
    "sentence": "Middag lagar vi tillsammans.",
    "sentenceTranslation": "Dinner we cook together."
  },
  {
    "wordId": 19,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Glas",
    "english": "Glass",
    "pronunciation": "Glaas",
    "sentence": "Glas är gjort av sand.",
    "sentenceTranslation": "Glass is made of sand."
  },
  {
    "wordId": 20,
    "setId": 6,
    "setName": "6. Food & Drink",
    "swedish": "Tallrik",
    "english": "Plate",
    "pronunciation": "Tal-reek",
    "sentence": "Tallrik och bestick ligger här.",
    "sentenceTranslation": "Plate and cutlery lie here."
  },
  {
    "wordId": 1,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Hus",
    "english": "House",
    "pronunciation": "Hoos",
    "sentence": "Hus är dyra att köpa.",
    "sentenceTranslation": "Houses are expensive to buy."
  },
  {
    "wordId": 2,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Lägenhet",
    "english": "Apartment",
    "pronunciation": "Lay-gen-het",
    "sentence": "Lägenhet kan vara stor.",
    "sentenceTranslation": "An apartment can be big."
  },
  {
    "wordId": 3,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Rum",
    "english": "Room",
    "pronunciation": "Rum",
    "sentence": "Rum finns i mitt hus.",
    "sentenceTranslation": "Rooms exist in my house."
  },
  {
    "wordId": 4,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Kök",
    "english": "Kitchen",
    "pronunciation": "Shuk",
    "sentence": "Kök är platsen där vi lagar mat.",
    "sentenceTranslation": "The kitchen is the place where we cook food."
  },
  {
    "wordId": 5,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Toalett",
    "english": "Toilet",
    "pronunciation": "Toah-lett",
    "sentence": "Toalett finns på andra våningen.",
    "sentenceTranslation": "A toilet is on the second floor."
  },
  {
    "wordId": 6,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Badrum",
    "english": "Bathroom",
    "pronunciation": "Bad-rum",
    "sentence": "Badrum är ofta rent.",
    "sentenceTranslation": "A bathroom is often clean."
  },
  {
    "wordId": 7,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Sovrum",
    "english": "Bedroom",
    "pronunciation": "Sohv-rum",
    "sentence": "Sovrum är för att sova.",
    "sentenceTranslation": "A bedroom is for sleeping."
  },
  {
    "wordId": 8,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Dörr",
    "english": "Door",
    "pronunciation": "Dur",
    "sentence": "Dörr är gjord av trä.",
    "sentenceTranslation": "A door is made of wood."
  },
  {
    "wordId": 9,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Fönster",
    "english": "Window",
    "pronunciation": "Fuhn-ster",
    "sentence": "Fönster släpper in ljus.",
    "sentenceTranslation": "Windows let in light."
  },
  {
    "wordId": 10,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Golv",
    "english": "Floor",
    "pronunciation": "Golv",
    "sentence": "Golv är hårt.",
    "sentenceTranslation": "The floor is hard."
  },
  {
    "wordId": 11,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Vägg",
    "english": "Wall",
    "pronunciation": "Vegg",
    "sentence": "Vägg är målad i vitt.",
    "sentenceTranslation": "The wall is painted in white."
  },
  {
    "wordId": 12,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Bord",
    "english": "Table",
    "pronunciation": "Boord",
    "sentence": "Bord står i vardagsrummet.",
    "sentenceTranslation": "The table stands in the living room."
  },
  {
    "wordId": 13,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Stol",
    "english": "Chair",
    "pronunciation": "Stool",
    "sentence": "Stol är skön att sitta på.",
    "sentenceTranslation": "A chair is nice to sit on."
  },
  {
    "wordId": 14,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Säng",
    "english": "Bed",
    "pronunciation": "Seng",
    "sentence": "Säng finns i sovrummet.",
    "sentenceTranslation": "A bed is in the bedroom."
  },
  {
    "wordId": 15,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Soffa",
    "english": "Sofa",
    "pronunciation": "Sof-fah",
    "sentence": "Soffa är bekväm.",
    "sentenceTranslation": "The sofa is comfortable."
  },
  {
    "wordId": 16,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Lampa",
    "english": "Lamp",
    "pronunciation": "Lam-pah",
    "sentence": "Lampa lyser upp rummet.",
    "sentenceTranslation": "A lamp lights up the room."
  },
  {
    "wordId": 17,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Nyckel",
    "english": "Key",
    "pronunciation": "Nik-kel",
    "sentence": "Nyckel öppnar dörren.",
    "sentenceTranslation": "A key opens the door."
  },
  {
    "wordId": 18,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Dator",
    "english": "Computer",
    "pronunciation": "Dah-tor",
    "sentence": "Dator är viktig för mitt jobb.",
    "sentenceTranslation": "A computer is important for my job."
  },
  {
    "wordId": 19,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Telefon",
    "english": "Phone",
    "pronunciation": "Teh-leh-fon",
    "sentence": "Telefon ringer ofta.",
    "sentenceTranslation": "The telephone rings often."
  },
  {
    "wordId": 20,
    "setId": 7,
    "setName": "7. The Home",
    "swedish": "Tv",
    "english": "TV",
    "pronunciation": "Teh-veh",
    "sentence": "Tv visar en bra film.",
    "sentenceTranslation": "The TV is showing a good movie."
  },
  {
    "wordId": 1,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Tid",
    "english": "Time",
    "pronunciation": "Tid",
    "sentence": "Tid är viktigt för mig.",
    "sentenceTranslation": "Time is important to me."
  },
  {
    "wordId": 2,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Dag",
    "english": "Day",
    "pronunciation": "Daag",
    "sentence": "Dag efter dag studerar jag svenska.",
    "sentenceTranslation": "Day after day I study Swedish."
  },
  {
    "wordId": 3,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Natt",
    "english": "Night",
    "pronunciation": "Natt",
    "sentence": "Natt blir till dag varje morgon.",
    "sentenceTranslation": "Night turns to day every morning."
  },
  {
    "wordId": 4,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Vecka",
    "english": "Week",
    "pronunciation": "Vek-kah",
    "sentence": "Vecka efter vecka går så fort.",
    "sentenceTranslation": "Week after week goes so fast."
  },
  {
    "wordId": 5,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Månad",
    "english": "Month",
    "pronunciation": "Moh-nad",
    "sentence": "Månad för månad lär jag mig mer.",
    "sentenceTranslation": "Month by month I learn more."
  },
  {
    "wordId": 6,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "År",
    "english": "Year",
    "pronunciation": "Ohr",
    "sentence": "År efter år blir vi äldre.",
    "sentenceTranslation": "Year after year we get older."
  },
  {
    "wordId": 7,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Idag",
    "english": "Today",
    "pronunciation": "Ee-daag",
    "sentence": "Idag vill jag dricka kaffe.",
    "sentenceTranslation": "Today I want to drink coffee."
  },
  {
    "wordId": 8,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Imorgon",
    "english": "Tomorrow",
    "pronunciation": "Ee-mor-ron",
    "sentence": "Imorgon ska vi resa till Sverige.",
    "sentenceTranslation": "Tomorrow we will travel to Sweden."
  },
  {
    "wordId": 9,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Igår",
    "english": "Yesterday",
    "pronunciation": "Ee-gohr",
    "sentence": "Igår läste jag en bra bok.",
    "sentenceTranslation": "Yesterday I read a good book."
  },
  {
    "wordId": 10,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Morgon",
    "english": "Morning",
    "pronunciation": "Mor-ron",
    "sentence": "Morgon är min favorittid på dagen.",
    "sentenceTranslation": "Morning is my favorite time of the day."
  },
  {
    "wordId": 11,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Kväll",
    "english": "Evening",
    "pronunciation": "Kvell",
    "sentence": "Kväll är en tid för att vila.",
    "sentenceTranslation": "Evening is a time to rest."
  },
  {
    "wordId": 12,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Timme",
    "english": "Hour",
    "pronunciation": "Tim-meh",
    "sentence": "Timme efter timme väntar jag här.",
    "sentenceTranslation": "Hour after hour I wait here."
  },
  {
    "wordId": 13,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Minut",
    "english": "Minute",
    "pronunciation": "Min-oot",
    "sentence": "Minut för minut tickar klockan.",
    "sentenceTranslation": "Minute by minute the clock ticks."
  },
  {
    "wordId": 14,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Måndag",
    "english": "Monday",
    "pronunciation": "Mon-daag",
    "sentence": "Måndag är den första dagen i veckan.",
    "sentenceTranslation": "Monday is the first day of the week."
  },
  {
    "wordId": 15,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Tisdag",
    "english": "Tuesday",
    "pronunciation": "Tees-daag",
    "sentence": "Tisdag är en vanlig arbetsdag.",
    "sentenceTranslation": "Tuesday is a normal workday."
  },
  {
    "wordId": 16,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Onsdag",
    "english": "Wednesday",
    "pronunciation": "Ons-daag",
    "sentence": "Onsdag är mitt i veckan.",
    "sentenceTranslation": "Wednesday is in the middle of the week."
  },
  {
    "wordId": 17,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Torsdag",
    "english": "Thursday",
    "pronunciation": "Toors-daag",
    "sentence": "Torsdag kommer före fredag.",
    "sentenceTranslation": "Thursday comes before Friday."
  },
  {
    "wordId": 18,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Fredag",
    "english": "Friday",
    "pronunciation": "Freh-daag",
    "sentence": "Fredag är min favoritdag.",
    "sentenceTranslation": "Friday is my favorite day."
  },
  {
    "wordId": 19,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Lördag",
    "english": "Saturday",
    "pronunciation": "Lur-daag",
    "sentence": "Lördag är en härlig dag för fest.",
    "sentenceTranslation": "Saturday is a lovely day for a party."
  },
  {
    "wordId": 20,
    "setId": 8,
    "setName": "8. Time & Days",
    "swedish": "Söndag",
    "english": "Sunday",
    "pronunciation": "Suhn-daag",
    "sentence": "Söndag är en dag för vila.",
    "sentenceTranslation": "Sunday is a day for rest."
  },
  {
    "wordId": 1,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Mamma",
    "english": "Mom",
    "pronunciation": "Mam-mah",
    "sentence": "Mamma lagar god mat till oss.",
    "sentenceTranslation": "Mom cooks delicious food for us."
  },
  {
    "wordId": 2,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Pappa",
    "english": "Dad",
    "pronunciation": "Pap-pah",
    "sentence": "Pappa läser tidningen varje dag.",
    "sentenceTranslation": "Dad reads the newspaper every day."
  },
  {
    "wordId": 3,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Föräldrar",
    "english": "Parents",
    "pronunciation": "Fur-el-drar",
    "sentence": "Föräldrar älskar ofta sina barn.",
    "sentenceTranslation": "Parents often love their children."
  },
  {
    "wordId": 4,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Son",
    "english": "Son",
    "pronunciation": "Sohn",
    "sentence": "Son, kan du hjälpa mig nu?",
    "sentenceTranslation": "Son, can you help me now?"
  },
  {
    "wordId": 5,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Dotter",
    "english": "Daughter",
    "pronunciation": "Dot-ter",
    "sentence": "Dotter, du är mycket duktig.",
    "sentenceTranslation": "Daughter, you are very clever."
  },
  {
    "wordId": 6,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Bror",
    "english": "Brother",
    "pronunciation": "Broor",
    "sentence": "Bror, var snäll och lyssna på mig.",
    "sentenceTranslation": "Brother, please listen to me."
  },
  {
    "wordId": 7,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Syster",
    "english": "Sister",
    "pronunciation": "Sys-ter",
    "sentence": "Syster, vill du dricka te med mig?",
    "sentenceTranslation": "Sister, do you want to drink tea with me."
  },
  {
    "wordId": 8,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Syskon",
    "english": "Siblings",
    "pronunciation": "Sys-kon",
    "sentence": "Syskon kan ibland bråka lite.",
    "sentenceTranslation": "Siblings can sometimes fight a little."
  },
  {
    "wordId": 9,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Farfar",
    "english": "Grandpa (paternal)",
    "pronunciation": "Far-far",
    "sentence": "Farfar berättar roliga historier.",
    "sentenceTranslation": "Grandfather tells funny stories."
  },
  {
    "wordId": 10,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Farmor",
    "english": "Grandma (paternal)",
    "pronunciation": "Far-moor",
    "sentence": "Farmor bakar goda kakor.",
    "sentenceTranslation": "Grandmother bakes delicious cookies."
  },
  {
    "wordId": 11,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Morfar",
    "english": "Grandpa (maternal)",
    "pronunciation": "Moor-far",
    "sentence": "Morfar tycker om att fiska.",
    "sentenceTranslation": "Grandfather likes to fish."
  },
  {
    "wordId": 12,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Mormor",
    "english": "Grandma (maternal)",
    "pronunciation": "Moor-moor",
    "sentence": "Mormor stickar en varm tröja.",
    "sentenceTranslation": "Grandmother knits a warm sweater."
  },
  {
    "wordId": 13,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Man",
    "english": "Husband",
    "pronunciation": "Mann",
    "sentence": "Man och hustru bor i detta hus.",
    "sentenceTranslation": "Man and wife live in this house."
  },
  {
    "wordId": 14,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Fru",
    "english": "Wife",
    "pronunciation": "Froo",
    "sentence": "Fru Andersson arbetar på en skola.",
    "sentenceTranslation": "Mrs. Andersson works at a school."
  },
  {
    "wordId": 15,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Pojkvän",
    "english": "Boyfriend",
    "pronunciation": "Poyk-ven",
    "sentence": "Pojkvän och flickvän går på bio.",
    "sentenceTranslation": "Boyfriend and girlfriend go to the cinema."
  },
  {
    "wordId": 16,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Flickvän",
    "english": "Girlfriend",
    "pronunciation": "Flik-ven",
    "sentence": "Jag älskar min Flickvän.",
    "sentenceTranslation": "I love my girlfriend."
  },
  {
    "wordId": 17,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Släkt",
    "english": "Relatives",
    "pronunciation": "Slekt",
    "sentence": "Min Släkt är mycket stor.",
    "sentenceTranslation": "My family of relatives is very big."
  },
  {
    "wordId": 18,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Barnbarn",
    "english": "Grandchild",
    "pronunciation": "Baarn-baarn",
    "sentence": "Mitt Barnbarn är tre år gammalt.",
    "sentenceTranslation": "My grandchild is three years old."
  },
  {
    "wordId": 19,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Kompis",
    "english": "Buddy",
    "pronunciation": "Kom-pis",
    "sentence": "Min Kompis bor i Stockholm.",
    "sentenceTranslation": "My friend lives in Stockholm."
  },
  {
    "wordId": 20,
    "setId": 9,
    "setName": "9. Family",
    "swedish": "Granne",
    "english": "Neighbor",
    "pronunciation": "Gran-neh",
    "sentence": "Min Granne är mycket trevlig.",
    "sentenceTranslation": "My neighbor is very friendly."
  },
  {
    "wordId": 1,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Färg",
    "english": "Color",
    "pronunciation": "Ferry",
    "sentence": "Vilken Färg gillar du mest?",
    "sentenceTranslation": "Which color do you like the most?"
  },
  {
    "wordId": 2,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Röd",
    "english": "Red",
    "pronunciation": "Rurd",
    "sentence": "Min bil är Röd.",
    "sentenceTranslation": "My car is red."
  },
  {
    "wordId": 3,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Blå",
    "english": "Blue",
    "pronunciation": "Bloh",
    "sentence": "Himlen är Blå idag.",
    "sentenceTranslation": "The sky is blue today."
  },
  {
    "wordId": 4,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Gul",
    "english": "Yellow",
    "pronunciation": "Gool",
    "sentence": "Solen är Gul och varm.",
    "sentenceTranslation": "The sun is yellow and warm."
  },
  {
    "wordId": 5,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Grön",
    "english": "Green",
    "pronunciation": "Gruhn",
    "sentence": "Skogen är Grön på sommaren.",
    "sentenceTranslation": "The forest is green in the summer."
  },
  {
    "wordId": 6,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Svart",
    "english": "Black",
    "pronunciation": "Svart",
    "sentence": "Katten är helt Svart.",
    "sentenceTranslation": "The cat is completely black."
  },
  {
    "wordId": 7,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Vit",
    "english": "White",
    "pronunciation": "Veet",
    "sentence": "Snön är Vit och kall.",
    "sentenceTranslation": "The snow is white and cold."
  },
  {
    "wordId": 8,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Grå",
    "english": "Grey",
    "pronunciation": "Groh",
    "sentence": "Hunden är liten och Grå.",
    "sentenceTranslation": "The dog is small and gray."
  },
  {
    "wordId": 9,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Brun",
    "english": "Brown",
    "pronunciation": "Broon",
    "sentence": "Hästen är stor och Brun.",
    "sentenceTranslation": "The horse is big and brown."
  },
  {
    "wordId": 10,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Rosa",
    "english": "Pink",
    "pronunciation": "Roh-sah",
    "sentence": "Min tröja är Rosa.",
    "sentenceTranslation": "My sweater is pink."
  },
  {
    "wordId": 11,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Kläder",
    "english": "Clothes",
    "pronunciation": "Klay-der",
    "sentence": "Mina Kläder är rena nu.",
    "sentenceTranslation": "My clothes are clean now."
  },
  {
    "wordId": 12,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Tröja",
    "english": "Sweater/Shirt",
    "pronunciation": "Truy-yah",
    "sentence": "Jag har en varm Tröja.",
    "sentenceTranslation": "I have a warm sweater."
  },
  {
    "wordId": 13,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Byxor",
    "english": "Pants",
    "pronunciation": "Byx-or",
    "sentence": "Dina Byxor är mycket snygga.",
    "sentenceTranslation": "Your pants are very stylish."
  },
  {
    "wordId": 14,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Jacka",
    "english": "Jacket",
    "pronunciation": "Yak-kah",
    "sentence": "Min Jacka hänger i hallen.",
    "sentenceTranslation": "My jacket is hanging in the hallway."
  },
  {
    "wordId": 15,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Skor",
    "english": "Shoes",
    "pronunciation": "Skoor",
    "sentence": "Mina Skor är helt nya.",
    "sentenceTranslation": "My shoes are brand new."
  },
  {
    "wordId": 16,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Klänning",
    "english": "Dress",
    "pronunciation": "Klen-ning",
    "sentence": "Hon har en fin Klänning.",
    "sentenceTranslation": "She has a nice dress."
  },
  {
    "wordId": 17,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Kjol",
    "english": "Skirt",
    "pronunciation": "Shool",
    "sentence": "Hennes Kjol är ganska kort.",
    "sentenceTranslation": "Her skirt is quite short."
  },
  {
    "wordId": 18,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Mössa",
    "english": "Hat/Beanie",
    "pronunciation": "Muhs-sah",
    "sentence": "Jag har en röd Mössa på huvudet.",
    "sentenceTranslation": "I have a red beanie on my head."
  },
  {
    "wordId": 19,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Strumpor",
    "english": "Socks",
    "pronunciation": "Strum-por",
    "sentence": "Mina Strumpor är gjorda av ull.",
    "sentenceTranslation": "My socks are made of wool."
  },
  {
    "wordId": 20,
    "setId": 10,
    "setName": "10. Colors & Clothes",
    "swedish": "Glasögon",
    "english": "Glasses",
    "pronunciation": "Glaas-uh-gon",
    "sentence": "Mina Glasögon ligger på bordet.",
    "sentenceTranslation": "My glasses are on the table."
  },
  {
    "wordId": 1,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Stad",
    "english": "City",
    "pronunciation": "Staad",
    "sentence": "Stockholm är en vacker Stad.",
    "sentenceTranslation": "Stockholm is a beautiful city."
  },
  {
    "wordId": 2,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Gata",
    "english": "Street",
    "pronunciation": "Gah-tah",
    "sentence": "Detta är en mycket lång Gata.",
    "sentenceTranslation": "This is a very long street."
  },
  {
    "wordId": 3,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Affär",
    "english": "Shop",
    "pronunciation": "Ah-fair",
    "sentence": "Jag går till en Affär för att handla.",
    "sentenceTranslation": "I am going to a store to shop."
  },
  {
    "wordId": 4,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Restaurang",
    "english": "Restaurant",
    "pronunciation": "Res-to-rang",
    "sentence": "Vi äter middag på en bra Restaurang.",
    "sentenceTranslation": "We are eating dinner at a good restaurant."
  },
  {
    "wordId": 5,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Skola",
    "english": "School",
    "pronunciation": "Skoo-lah",
    "sentence": "Min dotter går i en stor Skola.",
    "sentenceTranslation": "My daughter goes to a big school."
  },
  {
    "wordId": 6,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Sjukhus",
    "english": "Hospital",
    "pronunciation": "Shook-hoos",
    "sentence": "Han arbetar som läkare på ett Sjukhus.",
    "sentenceTranslation": "He works as a doctor at a hospital."
  },
  {
    "wordId": 7,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Apotek",
    "english": "Pharmacy",
    "pronunciation": "Ah-po-tek",
    "sentence": "Jag måste köpa medicin på ett Apotek.",
    "sentenceTranslation": "I must buy medicine at a pharmacy."
  },
  {
    "wordId": 8,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Hotell",
    "english": "Hotel",
    "pronunciation": "Ho-tell",
    "sentence": "Vi ska bo på ett fint Hotell.",
    "sentenceTranslation": "We are going to stay at a nice hotel."
  },
  {
    "wordId": 9,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Bank",
    "english": "Bank",
    "pronunciation": "Bank",
    "sentence": "Jag har ett möte på en Bank imorgon.",
    "sentenceTranslation": "I have a meeting at a bank tomorrow."
  },
  {
    "wordId": 10,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Park",
    "english": "Park",
    "pronunciation": "Park",
    "sentence": "Vi tar en promenad i en grön Park.",
    "sentenceTranslation": "We are taking a walk in a green park."
  },
  {
    "wordId": 11,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Bibliotek",
    "english": "Library",
    "pronunciation": "Bib-lee-o-tek",
    "sentence": "Bibliotek har många böcker.",
    "sentenceTranslation": "Libraries have many books."
  },
  {
    "wordId": 12,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Torg",
    "english": "Square",
    "pronunciation": "Torr-g",
    "sentence": "Torg är öppna platser i städer.",
    "sentenceTranslation": "Squares are open places in cities."
  },
  {
    "wordId": 13,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Bro",
    "english": "Bridge",
    "pronunciation": "Broo",
    "sentence": "Bro efter bro leder över floden.",
    "sentenceTranslation": "Bridge after bridge leads over the river."
  },
  {
    "wordId": 14,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Kyrka",
    "english": "Church",
    "pronunciation": "Shyr-kah",
    "sentence": "Kyrka är en gammal byggnad.",
    "sentenceTranslation": "A church is an old building."
  },
  {
    "wordId": 15,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Station",
    "english": "Station",
    "pronunciation": "Sta-shoon",
    "sentence": "Station är där tåget stannar.",
    "sentenceTranslation": "A station is where the train stops."
  },
  {
    "wordId": 16,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Flygplats",
    "english": "Airport",
    "pronunciation": "Flyg-plats",
    "sentence": "Flygplats finns utanför staden.",
    "sentenceTranslation": "An airport is located outside the city."
  },
  {
    "wordId": 17,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Centrum",
    "english": "Center",
    "pronunciation": "Sen-trum",
    "sentence": "Centrum har många affärer.",
    "sentenceTranslation": "The city center has many shops."
  },
  {
    "wordId": 18,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Bio",
    "english": "Cinema",
    "pronunciation": "Bee-oh",
    "sentence": "Bio är kul att gå på.",
    "sentenceTranslation": "Going to the cinema is fun."
  },
  {
    "wordId": 19,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Strand",
    "english": "Beach",
    "pronunciation": "Strand",
    "sentence": "Strand efter strand ligger längs kusten.",
    "sentenceTranslation": "Beach after beach lies along the coast."
  },
  {
    "wordId": 20,
    "setId": 11,
    "setName": "11. City & Places",
    "swedish": "Land",
    "english": "Country",
    "pronunciation": "Land",
    "sentence": "Land efter land stänger gränsen.",
    "sentenceTranslation": "Country after country closes the border."
  },
  {
    "wordId": 1,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Bil",
    "english": "Car",
    "pronunciation": "Beel",
    "sentence": "Bil är ett snabbt fordon.",
    "sentenceTranslation": "A car is a fast vehicle."
  },
  {
    "wordId": 2,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Buss",
    "english": "Bus",
    "pronunciation": "Buss",
    "sentence": "Buss är billigt att åka.",
    "sentenceTranslation": "Bus is cheap to ride."
  },
  {
    "wordId": 3,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Tåg",
    "english": "Train",
    "pronunciation": "Tohg",
    "sentence": "Tåg är bra för miljön.",
    "sentenceTranslation": "Trains are good for the environment."
  },
  {
    "wordId": 4,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Cykel",
    "english": "Bike",
    "pronunciation": "Sy-kel",
    "sentence": "Cykel är ett bra transportmedel.",
    "sentenceTranslation": "A bicycle is a good means of transport."
  },
  {
    "wordId": 5,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Båt",
    "english": "Boat",
    "pronunciation": "Boht",
    "sentence": "Båt flyter på vattnet.",
    "sentenceTranslation": "A boat floats on the water."
  },
  {
    "wordId": 6,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Flygplan",
    "english": "Airplane",
    "pronunciation": "Flyg-plaan",
    "sentence": "Flygplan flyger i luften.",
    "sentenceTranslation": "Airplanes fly in the air."
  },
  {
    "wordId": 7,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Tunnelbana",
    "english": "Subway",
    "pronunciation": "Tun-nel-bah-nah",
    "sentence": "Tunnelbana finns i Stockholm.",
    "sentenceTranslation": "Subway exists in Stockholm."
  },
  {
    "wordId": 8,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Biljett",
    "english": "Ticket",
    "pronunciation": "Bil-yett",
    "sentence": "Biljett behövs för resan.",
    "sentenceTranslation": "A ticket is needed for the trip."
  },
  {
    "wordId": 9,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Resa",
    "english": "Trip",
    "pronunciation": "Reh-sah",
    "sentence": "Resa är mycket roligt.",
    "sentenceTranslation": "Traveling is very fun."
  },
  {
    "wordId": 10,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Stannar",
    "english": "Stops",
    "pronunciation": "Stan-nar",
    "sentence": "Stannar bussen här?",
    "sentenceTranslation": "Does the bus stop here?"
  },
  {
    "wordId": 11,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Åker",
    "english": "Goes/Rides",
    "pronunciation": "Oh-ker",
    "sentence": "Åker du hem nu?",
    "sentenceTranslation": "Are you going home now?"
  },
  {
    "wordId": 12,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Kör",
    "english": "Drive",
    "pronunciation": "Shur",
    "sentence": "Kör du försiktigt?",
    "sentenceTranslation": "Do you drive carefully?"
  },
  {
    "wordId": 13,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Väg",
    "english": "Road",
    "pronunciation": "Vahg",
    "sentence": "Väg efter väg leder hem.",
    "sentenceTranslation": "Road after road leads home."
  },
  {
    "wordId": 14,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Karta",
    "english": "Map",
    "pronunciation": "Kar-tah",
    "sentence": "Karta visar vägen.",
    "sentenceTranslation": "A map shows the way."
  },
  {
    "wordId": 15,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Hållplats",
    "english": "Stop (bus)",
    "pronunciation": "Holl-plats",
    "sentence": "Hållplats för bussen är här.",
    "sentenceTranslation": "The bus stop is here."
  },
  {
    "wordId": 16,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Ingång",
    "english": "Entrance",
    "pronunciation": "In-gong",
    "sentence": "Ingång är på andra sidan.",
    "sentenceTranslation": "The entrance is on the other side."
  },
  {
    "wordId": 17,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Utgång",
    "english": "Exit",
    "pronunciation": "Oot-gong",
    "sentence": "Utgång är rakt fram.",
    "sentenceTranslation": "The exit is straight ahead."
  },
  {
    "wordId": 18,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Försenad",
    "english": "Delayed",
    "pronunciation": "Fur-seh-nad",
    "sentence": "Försenad avgång är tråkigt.",
    "sentenceTranslation": "Delayed departure is boring."
  },
  {
    "wordId": 19,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Pass",
    "english": "Passport",
    "pronunciation": "Pass",
    "sentence": "Pass måste du ha med dig.",
    "sentenceTranslation": "A passport you must have with you."
  },
  {
    "wordId": 20,
    "setId": 12,
    "setName": "12. Transport",
    "swedish": "Väska",
    "english": "Bag",
    "pronunciation": "Ves-kah",
    "sentence": "Väska är bra för packning.",
    "sentenceTranslation": "A bag is good for packing."
  },
  {
    "wordId": 1,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Kropp",
    "english": "Body",
    "pronunciation": "Krop",
    "sentence": "Kropp och själ hör ihop.",
    "sentenceTranslation": "Body and soul belong together."
  },
  {
    "wordId": 2,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Huvud",
    "english": "Head",
    "pronunciation": "Hoo-vud",
    "sentence": "Huvud och axlar gör ont.",
    "sentenceTranslation": "Head and shoulders hurt."
  },
  {
    "wordId": 3,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Hår",
    "english": "Hair",
    "pronunciation": "Hohr",
    "sentence": "Hår växer på huvudet.",
    "sentenceTranslation": "Hair grows on the head."
  },
  {
    "wordId": 4,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Öga",
    "english": "Eye",
    "pronunciation": "Uh-gah",
    "sentence": "Öga mot öga ser vi allt.",
    "sentenceTranslation": "Eye to eye we see everything."
  },
  {
    "wordId": 5,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Öra",
    "english": "Ear",
    "pronunciation": "Uh-rah",
    "sentence": "Öra är till för att höra.",
    "sentenceTranslation": "An ear is for hearing."
  },
  {
    "wordId": 6,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Näsa",
    "english": "Nose",
    "pronunciation": "Neh-sah",
    "sentence": "Näsa är en del av ansiktet.",
    "sentenceTranslation": "Nose is a part of the face."
  },
  {
    "wordId": 7,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Mun",
    "english": "Mouth",
    "pronunciation": "Mun",
    "sentence": "Mun är en del av ansiktet.",
    "sentenceTranslation": "Mouth is a part of the face."
  },
  {
    "wordId": 8,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Hand",
    "english": "Hand",
    "pronunciation": "Hand",
    "sentence": "Hand är en del av kroppen.",
    "sentenceTranslation": "Hand is a part of the body."
  },
  {
    "wordId": 9,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Arm",
    "english": "Arm",
    "pronunciation": "Arm",
    "sentence": "Arm är en del av kroppen.",
    "sentenceTranslation": "Arm is a part of the body."
  },
  {
    "wordId": 10,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Finger",
    "english": "Finger",
    "pronunciation": "Fing-er",
    "sentence": "Finger är en del av handen.",
    "sentenceTranslation": "Finger is a part of the hand."
  },
  {
    "wordId": 11,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Mage",
    "english": "Stomach",
    "pronunciation": "Mah-geh",
    "sentence": "Mage är en del av kroppen.",
    "sentenceTranslation": "Stomach is a part of the body."
  },
  {
    "wordId": 12,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Rygg",
    "english": "Back",
    "pronunciation": "Ryg",
    "sentence": "Rygg är en del av kroppen.",
    "sentenceTranslation": "Back is a part of the body."
  },
  {
    "wordId": 13,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Ben",
    "english": "Leg",
    "pronunciation": "Behn",
    "sentence": "Ben är bra att gå på.",
    "sentenceTranslation": "Legs are good to walk on."
  },
  {
    "wordId": 14,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Fot",
    "english": "Foot",
    "pronunciation": "Foot",
    "sentence": "Fot är en del av benet.",
    "sentenceTranslation": "Foot is a part of the leg."
  },
  {
    "wordId": 15,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Hjärta",
    "english": "Heart",
    "pronunciation": "Yar-tah",
    "sentence": "Hjärta finns i bröstet.",
    "sentenceTranslation": "Heart is in the chest."
  },
  {
    "wordId": 16,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Ont",
    "english": "Pain",
    "pronunciation": "Oont",
    "sentence": "Ont i huvudet är jobbigt.",
    "sentenceTranslation": "Having a headache is tough."
  },
  {
    "wordId": 17,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Sjuk",
    "english": "Sick",
    "pronunciation": "Shook",
    "sentence": "Sjuk blir man ibland.",
    "sentenceTranslation": "Sick one becomes sometimes."
  },
  {
    "wordId": 18,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Frisk",
    "english": "Healthy",
    "pronunciation": "Frisk",
    "sentence": "Frisk luft är bra för oss.",
    "sentenceTranslation": "Fresh air is good for us."
  },
  {
    "wordId": 19,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Trött",
    "english": "Tired",
    "pronunciation": "Trutt",
    "sentence": "Trött är jag efter en lång dag.",
    "sentenceTranslation": "Tired am I after a long day."
  },
  {
    "wordId": 20,
    "setId": 13,
    "setName": "13. The Body",
    "swedish": "Pigg",
    "english": "Alert/Energetic",
    "pronunciation": "Pigg",
    "sentence": "Pigg blir man av kaffe.",
    "sentenceTranslation": "Alert one becomes from coffee."
  },
  {
    "wordId": 1,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Väder",
    "english": "Weather",
    "pronunciation": "Veh-der",
    "sentence": "Väder pratar vi ofta om.",
    "sentenceTranslation": "Weather we often talk about."
  },
  {
    "wordId": 2,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Sol",
    "english": "Sun",
    "pronunciation": "Sool",
    "sentence": "Sol ger ljus och värme.",
    "sentenceTranslation": "Sun gives light and warmth."
  },
  {
    "wordId": 3,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Regn",
    "english": "Rain",
    "pronunciation": "Regn",
    "sentence": "Regn faller från himlen.",
    "sentenceTranslation": "Rain falls from the sky."
  },
  {
    "wordId": 4,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Snö",
    "english": "Snow",
    "pronunciation": "Snuh",
    "sentence": "Snö är vit och kall.",
    "sentenceTranslation": "Snow is white and cold."
  },
  {
    "wordId": 5,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Vind",
    "english": "Wind",
    "pronunciation": "Vind",
    "sentence": "Vind kan blåsa hårt.",
    "sentenceTranslation": "Wind can blow hard."
  },
  {
    "wordId": 6,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Moln",
    "english": "Cloud",
    "pronunciation": "Moln",
    "sentence": "Moln finns på himlen.",
    "sentenceTranslation": "Clouds are in the sky."
  },
  {
    "wordId": 7,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Himmel",
    "english": "Sky",
    "pronunciation": "Him-mel",
    "sentence": "Himmel är ofta blå på sommaren.",
    "sentenceTranslation": "Sky is often blue in the summer."
  },
  {
    "wordId": 8,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Träd",
    "english": "Tree",
    "pronunciation": "Trehd",
    "sentence": "Träd ger oss skugga.",
    "sentenceTranslation": "Trees give us shade."
  },
  {
    "wordId": 9,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Blomma",
    "english": "Flower",
    "pronunciation": "Blom-mah",
    "sentence": "Blomma är en fin växt.",
    "sentenceTranslation": "Flower is a nice plant."
  },
  {
    "wordId": 10,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Skog",
    "english": "Forest",
    "pronunciation": "Skoog",
    "sentence": "Skog är full av träd.",
    "sentenceTranslation": "Forest is full of trees."
  },
  {
    "wordId": 11,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Sjö",
    "english": "Lake",
    "pronunciation": "Shuh",
    "sentence": "Sjö är en plats med vatten.",
    "sentenceTranslation": "Lake is a place with water."
  },
  {
    "wordId": 12,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Hav",
    "english": "Sea/Ocean",
    "pronunciation": "Haav",
    "sentence": "Hav har salt vatten.",
    "sentenceTranslation": "Ocean has salty water."
  },
  {
    "wordId": 13,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Berg",
    "english": "Mountain",
    "pronunciation": "Bery",
    "sentence": "Berg är mycket höga.",
    "sentenceTranslation": "Mountains are very high."
  },
  {
    "wordId": 14,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Vinter",
    "english": "Winter",
    "pronunciation": "Vin-ter",
    "sentence": "Vinter är kall och mörk.",
    "sentenceTranslation": "Winter is cold and dark."
  },
  {
    "wordId": 15,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Vår",
    "english": "Spring",
    "pronunciation": "Vohr",
    "sentence": "Vår kommer efter vintern.",
    "sentenceTranslation": "Spring comes after winter."
  },
  {
    "wordId": 16,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Sommar",
    "english": "Summer",
    "pronunciation": "Som-mar",
    "sentence": "Sommar är min favoritsäsong.",
    "sentenceTranslation": "Summer is my favorite season."
  },
  {
    "wordId": 17,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Höst",
    "english": "Autumn",
    "pronunciation": "Hust",
    "sentence": "Höst har många gula löv.",
    "sentenceTranslation": "Autumn has many yellow leaves."
  },
  {
    "wordId": 18,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Mörk",
    "english": "Dark",
    "pronunciation": "Murk",
    "sentence": "Mörk är natten utan måne.",
    "sentenceTranslation": "Dark is the night without a moon."
  },
  {
    "wordId": 19,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Ljus",
    "english": "Light",
    "pronunciation": "Yoos",
    "sentence": "Ljus kommer från solen.",
    "sentenceTranslation": "Light comes from the sun."
  },
  {
    "wordId": 20,
    "setId": 14,
    "setName": "14. Nature & Weather",
    "swedish": "Natur",
    "english": "Nature",
    "pronunciation": "Na-toor",
    "sentence": "Natur är vacker att se på.",
    "sentenceTranslation": "Nature is beautiful to look at."
  },
  {
    "wordId": 1,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Glad",
    "english": "Happy",
    "pronunciation": "Glaad",
    "sentence": "Glad blir jag när solen skiner.",
    "sentenceTranslation": "I get happy when the sun shines."
  },
  {
    "wordId": 2,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Ledsen",
    "english": "Sad",
    "pronunciation": "Led-sen",
    "sentence": "Ledsen blir jag av den sorgliga filmen.",
    "sentenceTranslation": "I get sad from the sad movie."
  },
  {
    "wordId": 3,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Arg",
    "english": "Angry",
    "pronunciation": "Ary",
    "sentence": "Arg blir han när han förlorar spelet.",
    "sentenceTranslation": "He gets angry when he loses the game."
  },
  {
    "wordId": 4,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Rädd",
    "english": "Scared",
    "pronunciation": "Red",
    "sentence": "Rädd är jag inte för mörkret.",
    "sentenceTranslation": "I am not afraid of the dark."
  },
  {
    "wordId": 5,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Lugn",
    "english": "Calm",
    "pronunciation": "Lugn",
    "sentence": "Lugn är kvällen vid sjön.",
    "sentenceTranslation": "Calm is the evening by the lake."
  },
  {
    "wordId": 6,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Stressad",
    "english": "Stressed",
    "pronunciation": "Stres-sad",
    "sentence": "Stressad blir man av mycket arbete.",
    "sentenceTranslation": "One gets stressed by a lot of work."
  },
  {
    "wordId": 7,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Hungrig",
    "english": "Hungry",
    "pronunciation": "Hung-rig",
    "sentence": "Hungrig är hunden efter skogspromenaden.",
    "sentenceTranslation": "The dog is hungry after the walk in the forest."
  },
  {
    "wordId": 8,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Mätt",
    "english": "Full (food)",
    "pronunciation": "Mett",
    "sentence": "Mätt är jag efter den goda middagen.",
    "sentenceTranslation": "I am full after the delicious dinner."
  },
  {
    "wordId": 9,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Törstig",
    "english": "Thirsty",
    "pronunciation": "Tur-stig",
    "sentence": "Törstig blir man av att springa i värmen.",
    "sentenceTranslation": "One gets thirsty from running in the heat."
  },
  {
    "wordId": 10,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Kär",
    "english": "In love",
    "pronunciation": "Shair",
    "sentence": "Kär är han i sin nya flickvän.",
    "sentenceTranslation": "He is in love with his new girlfriend."
  },
  {
    "wordId": 11,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Ensam",
    "english": "Lonely",
    "pronunciation": "En-sam",
    "sentence": "Ensam sitter han och läser en bok.",
    "sentenceTranslation": "Alone he sits and reads a book."
  },
  {
    "wordId": 12,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Nöjd",
    "english": "Satisfied",
    "pronunciation": "Noyd",
    "sentence": "Nöjd är katten som sover i soffan.",
    "sentenceTranslation": "Satisfied is the cat sleeping on the sofa."
  },
  {
    "wordId": 13,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Orolig",
    "english": "Worried",
    "pronunciation": "Oo-ro-lig",
    "sentence": "Orolig är mamman när barnet är sjukt.",
    "sentenceTranslation": "The mother is worried when the child is sick."
  },
  {
    "wordId": 14,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Förvånad",
    "english": "Surprised",
    "pronunciation": "Fur-voh-nad",
    "sentence": "Förvånad blir jag över din fråga.",
    "sentenceTranslation": "I get surprised by your question."
  },
  {
    "wordId": 15,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Rolig",
    "english": "Funny",
    "pronunciation": "Roo-lig",
    "sentence": "Rolig är den här historien.",
    "sentenceTranslation": "Funny is this story."
  },
  {
    "wordId": 16,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Tråkig",
    "english": "Boring",
    "pronunciation": "Troh-kig",
    "sentence": "Tråkig är filmen som vi tittar på.",
    "sentenceTranslation": "Boring is the movie we are watching."
  },
  {
    "wordId": 17,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Intressant",
    "english": "Interesting",
    "pronunciation": "In-tres-sant",
    "sentence": "Intressant är boken om Sveriges historia.",
    "sentenceTranslation": "Interesting is the book about Sweden's history."
  },
  {
    "wordId": 18,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Konstig",
    "english": "Weird",
    "pronunciation": "Kon-stig",
    "sentence": "Konstig är doften från köket.",
    "sentenceTranslation": "Strange is the smell from the kitchen."
  },
  {
    "wordId": 19,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Galen",
    "english": "Crazy",
    "pronunciation": "Gah-len",
    "sentence": "Galen blir han om han inte får kaffe.",
    "sentenceTranslation": "Crazy he becomes if he does not get coffee."
  },
  {
    "wordId": 20,
    "setId": 15,
    "setName": "15. Feelings",
    "swedish": "Trevlig",
    "english": "Nice",
    "pronunciation": "Trehv-lig",
    "sentence": "Trevlig är mannen som hjälper oss.",
    "sentenceTranslation": "Nice is the man who is helping us."
  },
  {
    "wordId": 1,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Springer",
    "english": "Run",
    "pronunciation": "Spring-er",
    "sentence": "Springer hunden efter bollen?",
    "sentenceTranslation": "Is the dog running after the ball?"
  },
  {
    "wordId": 2,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Hoppar",
    "english": "Jump",
    "pronunciation": "Hop-par",
    "sentence": "Hoppar barnet i vattenpölen?",
    "sentenceTranslation": "Is the child jumping in the puddle?"
  },
  {
    "wordId": 3,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Sitter",
    "english": "Sit",
    "pronunciation": "Sit-ter",
    "sentence": "Sitter du på stolen nu?",
    "sentenceTranslation": "Are you sitting on the chair now?"
  },
  {
    "wordId": 4,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Står",
    "english": "Stand",
    "pronunciation": "Stohr",
    "sentence": "Står bilen parkerad utanför huset?",
    "sentenceTranslation": "Is the car parked outside the house?"
  },
  {
    "wordId": 5,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Ligger",
    "english": "Lie down",
    "pronunciation": "Lig-ger",
    "sentence": "Ligger katten och sover i sängen?",
    "sentenceTranslation": "Is the cat lying and sleeping in the bed?"
  },
  {
    "wordId": 6,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Går",
    "english": "Walk",
    "pronunciation": "Gohr",
    "sentence": "Går vi till parken tillsammans?",
    "sentenceTranslation": "Are we walking to the park together?"
  },
  {
    "wordId": 7,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Simmar",
    "english": "Swim",
    "pronunciation": "Sim-mar",
    "sentence": "Simmar fisken snabbt i akvariet?",
    "sentenceTranslation": "Is the fish swimming fast in the aquarium?"
  },
  {
    "wordId": 8,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Dansar",
    "english": "Dance",
    "pronunciation": "Dan-sar",
    "sentence": "Dansar de på bröllopet?",
    "sentenceTranslation": "Are they dancing at the wedding?"
  },
  {
    "wordId": 9,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Ramlar",
    "english": "Fall",
    "pronunciation": "Ram-lar",
    "sentence": "Ramlar äpplet ner från trädet?",
    "sentenceTranslation": "Is the apple falling down from the tree?"
  },
  {
    "wordId": 10,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Kastar",
    "english": "Throw",
    "pronunciation": "Kas-tar",
    "sentence": "Kastar du bollen till mig?",
    "sentenceTranslation": "Are you throwing the ball to me?"
  },
  {
    "wordId": 11,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Fångar",
    "english": "Catch",
    "pronunciation": "Fong-ar",
    "sentence": "Fångar måsen en fisk i sjön?",
    "sentenceTranslation": "Is the seagull catching a fish in the lake?"
  },
  {
    "wordId": 12,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Bär",
    "english": "Carry",
    "pronunciation": "Bare",
    "sentence": "Bär han den tunga väskan?",
    "sentenceTranslation": "Is he carrying the heavy bag?"
  },
  {
    "wordId": 13,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Lyfter",
    "english": "Lift",
    "pronunciation": "Lyf-ter",
    "sentence": "Lyfter du på locket till lådan?",
    "sentenceTranslation": "Are you lifting the lid of the box?"
  },
  {
    "wordId": 14,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Stänger",
    "english": "Close",
    "pronunciation": "Steng-er",
    "sentence": "Stänger affären klockan åtta ikväll?",
    "sentenceTranslation": "Is the store closing at eight o'clock tonight?"
  },
  {
    "wordId": 15,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Öppnar",
    "english": "Open",
    "pronunciation": "Up-nar",
    "sentence": "Öppnar du dörren för gästerna?",
    "sentenceTranslation": "Are you opening the door for the guests?"
  },
  {
    "wordId": 16,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Drary",
    "english": "Pull",
    "pronunciation": "Drar",
    "sentence": "Min hund heter Drary.",
    "sentenceTranslation": "My dog is named Drary."
  },
  {
    "wordId": 17,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Trycker",
    "english": "Push",
    "pronunciation": "Tryk-ker",
    "sentence": "Jag trycker på knappen.",
    "sentenceTranslation": "I press the button."
  },
  {
    "wordId": 18,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Väntar",
    "english": "Wait",
    "pronunciation": "Ven-tar",
    "sentence": "Jag väntar på bussen.",
    "sentenceTranslation": "I am waiting for the bus."
  },
  {
    "wordId": 19,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Skyndar",
    "english": "Hurry",
    "pronunciation": "Shyn-dar",
    "sentence": "Jag skyndar mig till skolan.",
    "sentenceTranslation": "I hurry to school."
  },
  {
    "wordId": 20,
    "setId": 16,
    "setName": "16. Motion Verbs",
    "swedish": "Stannar",
    "english": "Stop",
    "pronunciation": "Stan-nar",
    "sentence": "Bussen stannar här.",
    "sentenceTranslation": "The bus stops here."
  },
  {
    "wordId": 1,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Arbete",
    "english": "Work",
    "pronunciation": "Ar-beh-teh",
    "sentence": "Jag har ett roligt arbete.",
    "sentenceTranslation": "I have a fun job."
  },
  {
    "wordId": 2,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Kontor",
    "english": "Office",
    "pronunciation": "Kon-toor",
    "sentence": "Jag arbetar på ett kontor.",
    "sentenceTranslation": "I work in an office."
  },
  {
    "wordId": 3,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Chef",
    "english": "Boss",
    "pronunciation": "Sheff",
    "sentence": "Min chef är snäll.",
    "sentenceTranslation": "My boss is kind."
  },
  {
    "wordId": 4,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Möte",
    "english": "Meeting",
    "pronunciation": "Muh-teh",
    "sentence": "Vi har ett möte nu.",
    "sentenceTranslation": "We have a meeting now."
  },
  {
    "wordId": 5,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Lärare",
    "english": "Teacher",
    "pronunciation": "Lay-rah-reh",
    "sentence": "Min lärare är snäll.",
    "sentenceTranslation": "My teacher is kind."
  },
  {
    "wordId": 6,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Student",
    "english": "Student",
    "pronunciation": "Stoo-dent",
    "sentence": "Jag är en student.",
    "sentenceTranslation": "I am a student."
  },
  {
    "wordId": 7,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Penna",
    "english": "Pen",
    "pronunciation": "Pen-nah",
    "sentence": "Jag har en röd penna.",
    "sentenceTranslation": "I have a red pen."
  },
  {
    "wordId": 8,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Papper",
    "english": "Paper",
    "pronunciation": "Pap-per",
    "sentence": "Jag skriver på ett papper.",
    "sentenceTranslation": "I am writing on a paper."
  },
  {
    "wordId": 9,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Bok",
    "english": "Book",
    "pronunciation": "Book",
    "sentence": "Jag läser en bra bok.",
    "sentenceTranslation": "I am reading a good book."
  },
  {
    "wordId": 10,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Läxa",
    "english": "Homework",
    "pronunciation": "Lex-ah",
    "sentence": "Jag gör min läxa nu.",
    "sentenceTranslation": "I am doing my homework now."
  },
  {
    "wordId": 11,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Prov",
    "english": "Test",
    "pronunciation": "Proov",
    "sentence": "Vi har ett prov imorgon.",
    "sentenceTranslation": "We have a test tomorrow."
  },
  {
    "wordId": 12,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Rast",
    "english": "Break",
    "pronunciation": "Rast",
    "sentence": "Vi tar en kort rast.",
    "sentenceTranslation": "We are taking a short break."
  },
  {
    "wordId": 13,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Lön",
    "english": "Salary",
    "pronunciation": "Luhn",
    "sentence": "Jag får min lön på fredag.",
    "sentenceTranslation": "I get my salary on Friday."
  },
  {
    "wordId": 14,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Företag",
    "english": "Company",
    "pronunciation": "Fur-eh-taag",
    "sentence": "Det är ett stort företag.",
    "sentenceTranslation": "It is a big company."
  },
  {
    "wordId": 15,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Dator",
    "english": "Computer",
    "pronunciation": "Dah-tor",
    "sentence": "Min dator är ny.",
    "sentenceTranslation": "My computer is new."
  },
  {
    "wordId": 16,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Mejl",
    "english": "Email",
    "pronunciation": "Meyl",
    "sentence": "Jag skickar ett mejl till dig.",
    "sentenceTranslation": "I am sending an email to you."
  },
  {
    "wordId": 17,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Fråga",
    "english": "Question",
    "pronunciation": "Froh-gah",
    "sentence": "Jag har en enkel fråga.",
    "sentenceTranslation": "I have a simple question."
  },
  {
    "wordId": 18,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Svar",
    "english": "Answer",
    "pronunciation": "Svaar",
    "sentence": "Jag vill ha ett svar nu.",
    "sentenceTranslation": "I want an answer now."
  },
  {
    "wordId": 19,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Kurs",
    "english": "Course",
    "pronunciation": "Kurrs",
    "sentence": "Jag går en kurs i svenska.",
    "sentenceTranslation": "I am taking a course in Swedish."
  },
  {
    "wordId": 20,
    "setId": 17,
    "setName": "17. Work & School",
    "swedish": "Språk",
    "english": "Language",
    "pronunciation": "Sprohk",
    "sentence": "Svenska är ett vackert språk.",
    "sentenceTranslation": "Swedish is a beautiful language."
  },
  {
    "wordId": 1,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Djur",
    "english": "Animal",
    "pronunciation": "Yoor",
    "sentence": "En hund är ett djur.",
    "sentenceTranslation": "A dog is an animal."
  },
  {
    "wordId": 2,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Hund",
    "english": "Dog",
    "pronunciation": "Hund",
    "sentence": "Jag har en glad hund.",
    "sentenceTranslation": "I have a happy dog."
  },
  {
    "wordId": 3,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Katt",
    "english": "Cat",
    "pronunciation": "Katt",
    "sentence": "Min katt sover på sängen.",
    "sentenceTranslation": "My cat sleeps on the bed."
  },
  {
    "wordId": 4,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Häst",
    "english": "Horse",
    "pronunciation": "Hest",
    "sentence": "En häst kan springa snabbt.",
    "sentenceTranslation": "A horse can run fast."
  },
  {
    "wordId": 5,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Fågel",
    "english": "Bird",
    "pronunciation": "Foh-gel",
    "sentence": "Jag ser en liten fågel.",
    "sentenceTranslation": "I see a little bird."
  },
  {
    "wordId": 6,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Ko",
    "english": "Cow",
    "pronunciation": "Koo",
    "sentence": "En ko ger oss mjölk.",
    "sentenceTranslation": "A cow gives us milk."
  },
  {
    "wordId": 7,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Gris",
    "english": "Pig",
    "pronunciation": "Grees",
    "sentence": "En gris gillar lera.",
    "sentenceTranslation": "A pig likes mud."
  },
  {
    "wordId": 8,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Får",
    "english": "Sheep",
    "pronunciation": "Fohr",
    "sentence": "Ett får har mjuk ull.",
    "sentenceTranslation": "A sheep has soft wool."
  },
  {
    "wordId": 9,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Mus",
    "english": "Mouse",
    "pronunciation": "Moos",
    "sentence": "En liten mus bor i väggen.",
    "sentenceTranslation": "A little mouse lives in the wall."
  },
  {
    "wordId": 10,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Lejon",
    "english": "Lion",
    "pronunciation": "Lay-on",
    "sentence": "Ett lejon bor i Afrika.",
    "sentenceTranslation": "A lion lives in Africa."
  },
  {
    "wordId": 11,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Björn",
    "english": "Bear",
    "pronunciation": "Byurn",
    "sentence": "Här är Björn.",
    "sentenceTranslation": "Here is Bear."
  },
  {
    "wordId": 12,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Varg",
    "english": "Wolf",
    "pronunciation": "Vary",
    "sentence": "Här är Varg.",
    "sentenceTranslation": "Here is Wolf."
  },
  {
    "wordId": 13,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Älg",
    "english": "Moose",
    "pronunciation": "Elj",
    "sentence": "Här är Älg.",
    "sentenceTranslation": "Here is Moose."
  },
  {
    "wordId": 14,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Spindel",
    "english": "Spider",
    "pronunciation": "Spin-del",
    "sentence": "Här är Spindel.",
    "sentenceTranslation": "Here is Spider."
  },
  {
    "wordId": 15,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Fluga",
    "english": "Fly",
    "pronunciation": "Floo-gah",
    "sentence": "Här är Fluga.",
    "sentenceTranslation": "Here is Fly."
  },
  {
    "wordId": 16,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Fisk",
    "english": "Fish",
    "pronunciation": "Fisk",
    "sentence": "Här är Fisk.",
    "sentenceTranslation": "Here is Fish."
  },
  {
    "wordId": 17,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Orm",
    "english": "Snake",
    "pronunciation": "Orm",
    "sentence": "Här är Orm.",
    "sentenceTranslation": "Here is Snake."
  },
  {
    "wordId": 18,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Anka",
    "english": "Duck",
    "pronunciation": "An-kah",
    "sentence": "Här är Anka.",
    "sentenceTranslation": "Here is Duck."
  },
  {
    "wordId": 19,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Kanin",
    "english": "Rabbit",
    "pronunciation": "Ka-neen",
    "sentence": "Här är Kanin.",
    "sentenceTranslation": "Here is Rabbit."
  },
  {
    "wordId": 20,
    "setId": 18,
    "setName": "18. Animals",
    "swedish": "Husdjur",
    "english": "Pet",
    "pronunciation": "Hoos-yoor",
    "sentence": "Här är Husdjur.",
    "sentenceTranslation": "Here is Pet."
  },
  {
    "wordId": 1,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "På",
    "english": "On",
    "pronunciation": "Poh",
    "sentence": "Här är På.",
    "sentenceTranslation": "Here is On."
  },
  {
    "wordId": 2,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "I",
    "english": "In",
    "pronunciation": "Ee",
    "sentence": "Här är I.",
    "sentenceTranslation": "Here is In."
  },
  {
    "wordId": 3,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Under",
    "english": "Under",
    "pronunciation": "Un-der",
    "sentence": "Här är Under.",
    "sentenceTranslation": "Here is Under."
  },
  {
    "wordId": 4,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Över",
    "english": "Over",
    "pronunciation": "Uh-ver",
    "sentence": "Här är Över.",
    "sentenceTranslation": "Here is Over."
  },
  {
    "wordId": 5,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Med",
    "english": "With",
    "pronunciation": "Mehd",
    "sentence": "Här är Med.",
    "sentenceTranslation": "Here is With."
  },
  {
    "wordId": 6,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Utan",
    "english": "Without",
    "pronunciation": "Oo-tan",
    "sentence": "Här är Utan.",
    "sentenceTranslation": "Here is Without."
  },
  {
    "wordId": 7,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Till",
    "english": "To",
    "pronunciation": "Till",
    "sentence": "Här är Till.",
    "sentenceTranslation": "Here is To."
  },
  {
    "wordId": 8,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Från",
    "english": "From",
    "pronunciation": "Frohn",
    "sentence": "Här är Från.",
    "sentenceTranslation": "Here is From."
  },
  {
    "wordId": 9,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Av",
    "english": "Of/By",
    "pronunciation": "Ahv",
    "sentence": "Här är Av.",
    "sentenceTranslation": "Here is Of/By."
  },
  {
    "wordId": 10,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "För",
    "english": "For",
    "pronunciation": "Fur",
    "sentence": "Här är För.",
    "sentenceTranslation": "Here is For."
  },
  {
    "wordId": 11,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Bakom",
    "english": "Behind",
    "pronunciation": "Bah-kom",
    "sentence": "Här är Bakom.",
    "sentenceTranslation": "Here is Behind."
  },
  {
    "wordId": 12,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Framför",
    "english": "In front of",
    "pronunciation": "Fram-fur",
    "sentence": "Här är Framför.",
    "sentenceTranslation": "Here is In front of."
  },
  {
    "wordId": 13,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Mellan",
    "english": "Between",
    "pronunciation": "Mel-lan",
    "sentence": "Här är Mellan.",
    "sentenceTranslation": "Here is Between."
  },
  {
    "wordId": 14,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Bredvid",
    "english": "Next to",
    "pronunciation": "Brehd-veed",
    "sentence": "Här är Bredvid.",
    "sentenceTranslation": "Here is Next to."
  },
  {
    "wordId": 15,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Inuti",
    "english": "Inside",
    "pronunciation": "In-uh-tee",
    "sentence": "Här är Inuti.",
    "sentenceTranslation": "Here is Inside."
  },
  {
    "wordId": 16,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Utanför",
    "english": "Outside",
    "pronunciation": "Oo-tan-fur",
    "sentence": "Här är Utanför.",
    "sentenceTranslation": "Here is Outside."
  },
  {
    "wordId": 17,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Nära",
    "english": "Near",
    "pronunciation": "Nair-ah",
    "sentence": "Här är Nära.",
    "sentenceTranslation": "Here is Near."
  },
  {
    "wordId": 18,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Långt bort",
    "english": "Far away",
    "pronunciation": "Longt bort",
    "sentence": "Här är Långt bort.",
    "sentenceTranslation": "Here is Far away."
  },
  {
    "wordId": 19,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Höger",
    "english": "Right",
    "pronunciation": "Huh-ger",
    "sentence": "Här är Höger.",
    "sentenceTranslation": "Here is Right."
  },
  {
    "wordId": 20,
    "setId": 19,
    "setName": "19. Prepositions",
    "swedish": "Vänster",
    "english": "Left",
    "pronunciation": "Ven-ster",
    "sentence": "Här är Vänster.",
    "sentenceTranslation": "Here is Left."
  },
  {
    "wordId": 1,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Alltid",
    "english": "Always",
    "pronunciation": "All-teed",
    "sentence": "Här är Alltid.",
    "sentenceTranslation": "Here is Always."
  },
  {
    "wordId": 2,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Aldrig",
    "english": "Never",
    "pronunciation": "All-drig",
    "sentence": "Här är Aldrig.",
    "sentenceTranslation": "Here is Never."
  },
  {
    "wordId": 3,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Ofta",
    "english": "Often",
    "pronunciation": "Of-tah",
    "sentence": "Här är Ofta.",
    "sentenceTranslation": "Here is Often."
  },
  {
    "wordId": 4,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Ibland",
    "english": "Sometimes",
    "pronunciation": "Ee-bland",
    "sentence": "Här är Ibland.",
    "sentenceTranslation": "Here is Sometimes."
  },
  {
    "wordId": 5,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Snart",
    "english": "Soon",
    "pronunciation": "Snart",
    "sentence": "Här är Snart.",
    "sentenceTranslation": "Here is Soon."
  },
  {
    "wordId": 6,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Nu",
    "english": "Now",
    "pronunciation": "Noo",
    "sentence": "Här är Nu.",
    "sentenceTranslation": "Here is Now."
  },
  {
    "wordId": 7,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Då",
    "english": "Then",
    "pronunciation": "Doh",
    "sentence": "Här är Då.",
    "sentenceTranslation": "Here is Then."
  },
  {
    "wordId": 8,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Kanske",
    "english": "Maybe",
    "pronunciation": "Kan-sheh",
    "sentence": "Här är Kanske.",
    "sentenceTranslation": "Here is Maybe."
  },
  {
    "wordId": 9,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Också",
    "english": "Also",
    "pronunciation": "Ok-soh",
    "sentence": "Här är Också.",
    "sentenceTranslation": "Here is Also."
  },
  {
    "wordId": 10,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Bara",
    "english": "Only",
    "pronunciation": "Bah-rah",
    "sentence": "Här är Bara.",
    "sentenceTranslation": "Here is Only."
  },
  {
    "wordId": 11,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Mycket",
    "english": "A lot",
    "pronunciation": "Myk-keh",
    "sentence": "Här är Mycket.",
    "sentenceTranslation": "Here is A lot."
  },
  {
    "wordId": 12,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Lite",
    "english": "A little",
    "pronunciation": "Lee-teh",
    "sentence": "Här är Lite.",
    "sentenceTranslation": "Here is A little."
  },
  {
    "wordId": 13,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Redan",
    "english": "Already",
    "pronunciation": "Reh-dan",
    "sentence": "Här är Redan.",
    "sentenceTranslation": "Here is Already."
  },
  {
    "wordId": 14,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Fortfarande",
    "english": "Still",
    "pronunciation": "Fort-fah-ran-deh",
    "sentence": "Här är Fortfarande.",
    "sentenceTranslation": "Here is Still."
  },
  {
    "wordId": 15,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Gärna",
    "english": "Gladly",
    "pronunciation": "Yair-nah",
    "sentence": "Här är Gärna.",
    "sentenceTranslation": "Here is Gladly."
  },
  {
    "wordId": 16,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Hemma",
    "english": "At home",
    "pronunciation": "Hem-mah",
    "sentence": "Här är Hemma.",
    "sentenceTranslation": "Here is At home."
  },
  {
    "wordId": 17,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Borta",
    "english": "Away",
    "pronunciation": "Bor-tah",
    "sentence": "Här är Borta.",
    "sentenceTranslation": "Here is Away."
  },
  {
    "wordId": 18,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Ute",
    "english": "Out",
    "pronunciation": "Oo-teh",
    "sentence": "Här är Ute.",
    "sentenceTranslation": "Here is Out."
  },
  {
    "wordId": 19,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Inne",
    "english": "In/Indoors",
    "pronunciation": "In-neh",
    "sentence": "Här är Inne.",
    "sentenceTranslation": "Here is In/Indoors."
  },
  {
    "wordId": 20,
    "setId": 20,
    "setName": "20. Adverbs",
    "swedish": "Sällan",
    "english": "Rarely",
    "pronunciation": "Sel-lan",
    "sentence": "Här är Sällan.",
    "sentenceTranslation": "Here is Rarely."
  },
  {
    "wordId": 1,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Äpple",
    "english": "Apple",
    "pronunciation": "Ep-pleh",
    "sentence": "Här är Äpple.",
    "sentenceTranslation": "Here is Apple."
  },
  {
    "wordId": 2,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Banan",
    "english": "Banana",
    "pronunciation": "Ba-naan",
    "sentence": "Här är Banan.",
    "sentenceTranslation": "Here is Banana."
  },
  {
    "wordId": 3,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Apelsin",
    "english": "Orange",
    "pronunciation": "A-pel-seen",
    "sentence": "Här är Apelsin.",
    "sentenceTranslation": "Here is Orange."
  },
  {
    "wordId": 4,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Päron",
    "english": "Pear",
    "pronunciation": "Pair-on",
    "sentence": "Här är Päron.",
    "sentenceTranslation": "Here is Pear."
  },
  {
    "wordId": 5,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Citron",
    "english": "Lemon",
    "pronunciation": "Si-troon",
    "sentence": "Här är Citron.",
    "sentenceTranslation": "Here is Lemon."
  },
  {
    "wordId": 6,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Jordgubbe",
    "english": "Strawberry",
    "pronunciation": "Yoord-gub-beh",
    "sentence": "Här är Jordgubbe.",
    "sentenceTranslation": "Here is Strawberry."
  },
  {
    "wordId": 7,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Tomat",
    "english": "Tomato",
    "pronunciation": "To-maat",
    "sentence": "Här är Tomat.",
    "sentenceTranslation": "Here is Tomato."
  },
  {
    "wordId": 8,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Gurka",
    "english": "Cucumber",
    "pronunciation": "Gur-kah",
    "sentence": "Här är Gurka.",
    "sentenceTranslation": "Here is Cucumber."
  },
  {
    "wordId": 9,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Lök",
    "english": "Onion",
    "pronunciation": "Luhk",
    "sentence": "Här är Lök.",
    "sentenceTranslation": "Here is Onion."
  },
  {
    "wordId": 10,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Vitlök",
    "english": "Garlic",
    "pronunciation": "Veet-luhk",
    "sentence": "Här är Vitlök.",
    "sentenceTranslation": "Here is Garlic."
  },
  {
    "wordId": 11,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Morot",
    "english": "Carrot",
    "pronunciation": "Moo-root",
    "sentence": "Här är Morot.",
    "sentenceTranslation": "Here is Carrot."
  },
  {
    "wordId": 12,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Potatis",
    "english": "Potato",
    "pronunciation": "Po-tah-tis",
    "sentence": "Här är Potatis.",
    "sentenceTranslation": "Here is Potato."
  },
  {
    "wordId": 13,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Sallad",
    "english": "Lettuce/Salad",
    "pronunciation": "Sal-lad",
    "sentence": "Här är Sallad.",
    "sentenceTranslation": "Here is Lettuce/Salad."
  },
  {
    "wordId": 14,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Paprika",
    "english": "Pepper",
    "pronunciation": "Pap-ree-kah",
    "sentence": "Här är Paprika.",
    "sentenceTranslation": "Here is Pepper."
  },
  {
    "wordId": 15,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Svamp",
    "english": "Mushroom",
    "pronunciation": "Svamp",
    "sentence": "Här är Svamp.",
    "sentenceTranslation": "Here is Mushroom."
  },
  {
    "wordId": 16,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Bär",
    "english": "Berry",
    "pronunciation": "Bare",
    "sentence": "Här är Bär.",
    "sentenceTranslation": "Here is Berry."
  },
  {
    "wordId": 17,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Druvor",
    "english": "Grapes",
    "pronunciation": "Droo-vor",
    "sentence": "Här är Druvor.",
    "sentenceTranslation": "Here is Grapes."
  },
  {
    "wordId": 18,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Majs",
    "english": "Corn",
    "pronunciation": "Majs",
    "sentence": "Här är Majs.",
    "sentenceTranslation": "Here is Corn."
  },
  {
    "wordId": 19,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Spenat",
    "english": "Spinach",
    "pronunciation": "Spe-naat",
    "sentence": "Här är Spenat.",
    "sentenceTranslation": "Here is Spinach."
  },
  {
    "wordId": 20,
    "setId": 21,
    "setName": "21. Fruits & Veg",
    "swedish": "Ärtor",
    "english": "Peas",
    "pronunciation": "Air-tor",
    "sentence": "Här är Ärtor.",
    "sentenceTranslation": "Here is Peas."
  },
  {
    "wordId": 1,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Internet",
    "english": "Internet",
    "pronunciation": "In-ter-net",
    "sentence": "Internet är fyllt av information.",
    "sentenceTranslation": "The Internet is filled with information."
  },
  {
    "wordId": 2,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Skärm",
    "english": "Screen",
    "pronunciation": "Shairm",
    "sentence": "Skärm saknas på min dator.",
    "sentenceTranslation": "A screen is missing from my computer."
  },
  {
    "wordId": 3,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Laddare",
    "english": "Charger",
    "pronunciation": "Lad-dah-reh",
    "sentence": "Laddare behövs till telefonen.",
    "sentenceTranslation": "A charger is needed for the phone."
  },
  {
    "wordId": 4,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Batteri",
    "english": "Battery",
    "pronunciation": "Bat-teh-ree",
    "sentence": "Batteri ger ström till mobilen.",
    "sentenceTranslation": "A battery provides power to the mobile phone."
  },
  {
    "wordId": 5,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Meddelande",
    "english": "Message",
    "pronunciation": "Meh-deh-lan-deh",
    "sentence": "Meddelande har skickats till dig.",
    "sentenceTranslation": "A message has been sent to you."
  },
  {
    "wordId": 6,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Bild",
    "english": "Picture",
    "pronunciation": "Bild",
    "sentence": "Bild visar hur man gör.",
    "sentenceTranslation": "A picture shows how to do it."
  },
  {
    "wordId": 7,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Film",
    "english": "Movie",
    "pronunciation": "Film",
    "sentence": "Film är roligt att titta på.",
    "sentenceTranslation": "Movies are fun to watch."
  },
  {
    "wordId": 8,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Nyheter",
    "english": "News",
    "pronunciation": "Ny-heh-ter",
    "sentence": "Nyheter läser jag varje dag.",
    "sentenceTranslation": "News I read every day."
  },
  {
    "wordId": 9,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Tidning",
    "english": "Newspaper",
    "pronunciation": "Tid-ning",
    "sentence": "Tidning köper jag på stationen.",
    "sentenceTranslation": "A newspaper I buy at the station."
  },
  {
    "wordId": 10,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Ljud",
    "english": "Sound",
    "pronunciation": "Yood",
    "sentence": "Ljud kommer från högtalaren.",
    "sentenceTranslation": "Sound comes from the speaker."
  },
  {
    "wordId": 11,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Lösenord",
    "english": "Password",
    "pronunciation": "Luh-sen-oord",
    "sentence": "Lösenord måste vara säkert.",
    "sentenceTranslation": "A password must be secure."
  },
  {
    "wordId": 12,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Sida",
    "english": "Page",
    "pronunciation": "See-dah",
    "sentence": "Sida ett är mycket intressant.",
    "sentenceTranslation": "Page one is very interesting."
  },
  {
    "wordId": 13,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "App",
    "english": "App",
    "pronunciation": "App",
    "sentence": "App finns att ladda ner nu.",
    "sentenceTranslation": "An app is available to download now."
  },
  {
    "wordId": 14,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Radio",
    "english": "Radio",
    "pronunciation": "Ra-dee-oh",
    "sentence": "Radio lyssnar vi på ofta.",
    "sentenceTranslation": "Radio we listen to often."
  },
  {
    "wordId": 15,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Musik",
    "english": "Music",
    "pronunciation": "Moo-seek",
    "sentence": "Musik gör mig mycket glad.",
    "sentenceTranslation": "Music makes me very happy."
  },
  {
    "wordId": 16,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Sång",
    "english": "Song",
    "pronunciation": "Song",
    "sentence": "Sång hörs från rummet.",
    "sentenceTranslation": "A song is heard from the room."
  },
  {
    "wordId": 17,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Tangentbord",
    "english": "Keyboard",
    "pronunciation": "Tan-yent-boord",
    "sentence": "Tangentbord använder jag för att skriva.",
    "sentenceTranslation": "A keyboard I use to write."
  },
  {
    "wordId": 18,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Mus",
    "english": "Mouse (computer)",
    "pronunciation": "Moos",
    "sentence": "Mus behövs till datorn.",
    "sentenceTranslation": "A mouse is needed for the computer."
  },
  {
    "wordId": 19,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Skriva",
    "english": "Type/Write",
    "pronunciation": "Skree-vah",
    "sentence": "Skriva är roligt.",
    "sentenceTranslation": "To write is fun."
  },
  {
    "wordId": 20,
    "setId": 22,
    "setName": "22. Tech & Media",
    "swedish": "Ringa",
    "english": "Call",
    "pronunciation": "Ring-ah",
    "sentence": "Ringa kan jag göra sen.",
    "sentenceTranslation": "To call I can do later."
  },
  {
    "wordId": 1,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Tänker",
    "english": "Think",
    "pronunciation": "Ten-ker",
    "sentence": "Tänker du på mig?",
    "sentenceTranslation": "Are you thinking of me?"
  },
  {
    "wordId": 2,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Tror",
    "english": "Believe",
    "pronunciation": "Troor",
    "sentence": "Tror du på det?",
    "sentenceTranslation": "Do you believe in that?"
  },
  {
    "wordId": 3,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Vet",
    "english": "Know (fact)",
    "pronunciation": "Veht",
    "sentence": "Vet du var han är?",
    "sentenceTranslation": "Do you know where he is?"
  },
  {
    "wordId": 4,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Känner",
    "english": "Feel/Know (person)",
    "pronunciation": "Shen-ner",
    "sentence": "Känner du min bror?",
    "sentenceTranslation": "Do you know my brother?"
  },
  {
    "wordId": 5,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Minns",
    "english": "Remember",
    "pronunciation": "Minns",
    "sentence": "Minns du vår sommar?",
    "sentenceTranslation": "Do you remember our summer?"
  },
  {
    "wordId": 6,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Glömmer",
    "english": "Forget",
    "pronunciation": "Glum-mer",
    "sentence": "Glömmer du alltid nycklarna?",
    "sentenceTranslation": "Do you always forget the keys?"
  },
  {
    "wordId": 7,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Lyssnar",
    "english": "Listen",
    "pronunciation": "Lys-nar",
    "sentence": "Lyssnar du på musik nu?",
    "sentenceTranslation": "Are you listening to music now?"
  },
  {
    "wordId": 8,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Tittar",
    "english": "Watch",
    "pronunciation": "Tit-tar",
    "sentence": "Tittar du på tv?",
    "sentenceTranslation": "Are you watching TV?"
  },
  {
    "wordId": 9,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Läser",
    "english": "Read",
    "pronunciation": "Lay-ser",
    "sentence": "Läser du en bok?",
    "sentenceTranslation": "Are you reading a book?"
  },
  {
    "wordId": 10,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Skriver",
    "english": "Write",
    "pronunciation": "Skree-ver",
    "sentence": "Skriver du ett brev?",
    "sentenceTranslation": "Are you writing a letter?"
  },
  {
    "wordId": 11,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Lär",
    "english": "Learn/Teach",
    "pronunciation": "Lair",
    "sentence": "Lär du dig svenska?",
    "sentenceTranslation": "Are you learning Swedish?"
  },
  {
    "wordId": 12,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Hoppas",
    "english": "Hope",
    "pronunciation": "Hop-pas",
    "sentence": "Hoppas du har en fin dag.",
    "sentenceTranslation": "Hope you have a nice day."
  },
  {
    "wordId": 13,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Önskar",
    "english": "Wish",
    "pronunciation": "Uhn-skar",
    "sentence": "Önskar du dig något?",
    "sentenceTranslation": "Do you wish for something?"
  },
  {
    "wordId": 14,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Beslutar",
    "english": "Decide",
    "pronunciation": "Be-sloo-tar",
    "sentence": "Beslutar du dig snart?",
    "sentenceTranslation": "Will you decide soon?"
  },
  {
    "wordId": 15,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Förklarar",
    "english": "Explain",
    "pronunciation": "Fur-klah-rar",
    "sentence": "Förklarar du detta för mig?",
    "sentenceTranslation": "Will you explain this to me?"
  },
  {
    "wordId": 16,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Diskuterar",
    "english": "Discuss",
    "pronunciation": "Dis-koo-teh-rar",
    "sentence": "Här är Diskuterar.",
    "sentenceTranslation": "Here is Discuss."
  },
  {
    "wordId": 17,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Betyder",
    "english": "Mean/Signify",
    "pronunciation": "Be-ty-der",
    "sentence": "Här är Betyder.",
    "sentenceTranslation": "Here is Mean/Signify."
  },
  {
    "wordId": 18,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Gissar",
    "english": "Guess",
    "pronunciation": "Gis-sar",
    "sentence": "Här är Gissar.",
    "sentenceTranslation": "Here is Guess."
  },
  {
    "wordId": 19,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Drömmer",
    "english": "Dream",
    "pronunciation": "Drum-mer",
    "sentence": "Här är Drömmer.",
    "sentenceTranslation": "Here is Dream."
  },
  {
    "wordId": 20,
    "setId": 23,
    "setName": "23. Comm. & Mind",
    "swedish": "Ljuger",
    "english": "Lie",
    "pronunciation": "Yoo-ger",
    "sentence": "Här är Ljuger.",
    "sentenceTranslation": "Here is Lie."
  },
  {
    "wordId": 1,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Pengar",
    "english": "Money",
    "pronunciation": "Peng-ar",
    "sentence": "Här är Pengar.",
    "sentenceTranslation": "Here is Money."
  },
  {
    "wordId": 2,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Pris",
    "english": "Price",
    "pronunciation": "Prees",
    "sentence": "Här är Pris.",
    "sentenceTranslation": "Here is Price."
  },
  {
    "wordId": 3,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Kostar",
    "english": "Cost",
    "pronunciation": "Kos-tar",
    "sentence": "Här är Kostar.",
    "sentenceTranslation": "Here is Cost."
  },
  {
    "wordId": 4,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Köper",
    "english": "Buy",
    "pronunciation": "Shuh-per",
    "sentence": "Här är Köper.",
    "sentenceTranslation": "Here is Buy."
  },
  {
    "wordId": 5,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Säljer",
    "english": "Sell",
    "pronunciation": "Sel-yer",
    "sentence": "Här är Säljer.",
    "sentenceTranslation": "Here is Sell."
  },
  {
    "wordId": 6,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Betalar",
    "english": "Pay",
    "pronunciation": "Be-tah-lar",
    "sentence": "Här är Betalar.",
    "sentenceTranslation": "Here is Pay."
  },
  {
    "wordId": 7,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Kvitto",
    "english": "Receipt",
    "pronunciation": "Kvit-to",
    "sentence": "Här är Kvitto.",
    "sentenceTranslation": "Here is Receipt."
  },
  {
    "wordId": 8,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Kort",
    "english": "Card",
    "pronunciation": "Koort",
    "sentence": "Här är Kort.",
    "sentenceTranslation": "Here is Card."
  },
  {
    "wordId": 9,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Kontanter",
    "english": "Cash",
    "pronunciation": "Kon-tan-ter",
    "sentence": "Här är Kontanter.",
    "sentenceTranslation": "Here is Cash."
  },
  {
    "wordId": 10,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Rea",
    "english": "Sale",
    "pronunciation": "Reh-ah",
    "sentence": "Här är Rea.",
    "sentenceTranslation": "Here is Sale."
  },
  {
    "wordId": 11,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Kassa",
    "english": "Checkout",
    "pronunciation": "Kas-sah",
    "sentence": "Här är Kassa.",
    "sentenceTranslation": "Here is Checkout."
  },
  {
    "wordId": 12,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Påse",
    "english": "Bag",
    "pronunciation": "Poh-seh",
    "sentence": "Här är Påse.",
    "sentenceTranslation": "Here is Bag."
  },
  {
    "wordId": 13,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Storlek",
    "english": "Size",
    "pronunciation": "Stoor-lehk",
    "sentence": "Här är Storlek.",
    "sentenceTranslation": "Here is Size."
  },
  {
    "wordId": 14,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Provrum",
    "english": "Fitting room",
    "pronunciation": "Proov-rum",
    "sentence": "Här är Provrum.",
    "sentenceTranslation": "Here is Fitting room."
  },
  {
    "wordId": 15,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Öppet",
    "english": "Open",
    "pronunciation": "Up-pet",
    "sentence": "Här är Öppet.",
    "sentenceTranslation": "Here is Open."
  },
  {
    "wordId": 16,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Stängt",
    "english": "Closed",
    "pronunciation": "Stengt",
    "sentence": "Här är Stängt.",
    "sentenceTranslation": "Here is Closed."
  },
  {
    "wordId": 17,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Kund",
    "english": "Customer",
    "pronunciation": "Kund",
    "sentence": "Här är Kund.",
    "sentenceTranslation": "Here is Customer."
  },
  {
    "wordId": 18,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Plånbok",
    "english": "Wallet",
    "pronunciation": "Plohn-book",
    "sentence": "Här är Plånbok.",
    "sentenceTranslation": "Here is Wallet."
  },
  {
    "wordId": 19,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Kronor",
    "english": "Crowns (SEK)",
    "pronunciation": "Kroo-nor",
    "sentence": "Här är Kronor.",
    "sentenceTranslation": "Here is Crowns (SEK)."
  },
  {
    "wordId": 20,
    "setId": 24,
    "setName": "24. Shopping",
    "swedish": "Växel",
    "english": "Change",
    "pronunciation": "Vex-el",
    "sentence": "Här är Växel.",
    "sentenceTranslation": "Here is Change."
  },
  {
    "wordId": 1,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Sjuk",
    "english": "Sick",
    "pronunciation": "Shook",
    "sentence": "Här är Sjuk.",
    "sentenceTranslation": "Here is Sick."
  },
  {
    "wordId": 2,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Läkare",
    "english": "Doctor",
    "pronunciation": "Lay-kah-reh",
    "sentence": "Här är Läkare.",
    "sentenceTranslation": "Here is Doctor."
  },
  {
    "wordId": 3,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Sjuksköterska",
    "english": "Nurse",
    "pronunciation": "Shook-shuh-ters-kah",
    "sentence": "Här är Sjuksköterska.",
    "sentenceTranslation": "Here is Nurse."
  },
  {
    "wordId": 4,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Medicin",
    "english": "Medicine",
    "pronunciation": "Me-di-seen",
    "sentence": "Här är Medicin.",
    "sentenceTranslation": "Here is Medicine."
  },
  {
    "wordId": 5,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Apotek",
    "english": "Pharmacy",
    "pronunciation": "A-po-tek",
    "sentence": "Här är Apotek.",
    "sentenceTranslation": "Here is Pharmacy."
  },
  {
    "wordId": 6,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Ambulans",
    "english": "Ambulance",
    "pronunciation": "Am-boo-lans",
    "sentence": "Här är Ambulans.",
    "sentenceTranslation": "Here is Ambulance."
  },
  {
    "wordId": 7,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Polis",
    "english": "Police",
    "pronunciation": "Po-lees",
    "sentence": "Här är Polis.",
    "sentenceTranslation": "Here is Police."
  },
  {
    "wordId": 8,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Brandkår",
    "english": "Fire department",
    "pronunciation": "Brand-kohr",
    "sentence": "Här är Brandkår.",
    "sentenceTranslation": "Here is Fire department."
  },
  {
    "wordId": 9,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Olycka",
    "english": "Accident",
    "pronunciation": "Oo-lyk-kah",
    "sentence": "Här är Olycka.",
    "sentenceTranslation": "Here is Accident."
  },
  {
    "wordId": 10,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Blod",
    "english": "Blood",
    "pronunciation": "Blood",
    "sentence": "Här är Blod.",
    "sentenceTranslation": "Here is Blood."
  },
  {
    "wordId": 11,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Feber",
    "english": "Fever",
    "pronunciation": "Feh-ber",
    "sentence": "Här är Feber.",
    "sentenceTranslation": "Here is Fever."
  },
  {
    "wordId": 12,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Hosta",
    "english": "Cough",
    "pronunciation": "Hos-tah",
    "sentence": "Här är Hosta.",
    "sentenceTranslation": "Here is Cough."
  },
  {
    "wordId": 13,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Förkylning",
    "english": "Cold (illness)",
    "pronunciation": "Fur-shyl-ning",
    "sentence": "Här är Förkylning.",
    "sentenceTranslation": "Here is Cold (illness)."
  },
  {
    "wordId": 14,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Tandläkare",
    "english": "Dentist",
    "pronunciation": "Tand-lay-kah-reh",
    "sentence": "Här är Tandläkare.",
    "sentenceTranslation": "Here is Dentist."
  },
  {
    "wordId": 15,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Akut",
    "english": "Emergency",
    "pronunciation": "A-koot",
    "sentence": "Här är Akut.",
    "sentenceTranslation": "Here is Emergency."
  },
  {
    "wordId": 16,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Plåster",
    "english": "Band-aid",
    "pronunciation": "Plos-ter",
    "sentence": "Här är Plåster.",
    "sentenceTranslation": "Here is Band-aid."
  },
  {
    "wordId": 17,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Värk",
    "english": "Ache",
    "pronunciation": "Verk",
    "sentence": "Här är Värk.",
    "sentenceTranslation": "Here is Ache."
  },
  {
    "wordId": 18,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Allvarlig",
    "english": "Serious",
    "pronunciation": "All-vaar-lig",
    "sentence": "Här är Allvarlig.",
    "sentenceTranslation": "Here is Serious."
  },
  {
    "wordId": 19,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Liv",
    "english": "Life",
    "pronunciation": "Leev",
    "sentence": "Här är Liv.",
    "sentenceTranslation": "Here is Life."
  },
  {
    "wordId": 20,
    "setId": 25,
    "setName": "25. Health",
    "swedish": "Död",
    "english": "Death",
    "pronunciation": "Dood",
    "sentence": "Här är Död.",
    "sentenceTranslation": "Here is Death."
  },
  {
    "wordId": 1,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Tjugo",
    "english": "Twenty",
    "pronunciation": "Shoo-go",
    "sentence": "Här är Tjugo.",
    "sentenceTranslation": "Here is Twenty."
  },
  {
    "wordId": 2,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Trettio",
    "english": "Thirty",
    "pronunciation": "Tret-tee",
    "sentence": "Här är Trettio.",
    "sentenceTranslation": "Here is Thirty."
  },
  {
    "wordId": 3,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Fyrtio",
    "english": "Forty",
    "pronunciation": "Fur-tee",
    "sentence": "Här är Fyrtio.",
    "sentenceTranslation": "Here is Forty."
  },
  {
    "wordId": 4,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Femtio",
    "english": "Fifty",
    "pronunciation": "Fem-tee",
    "sentence": "Här är Femtio.",
    "sentenceTranslation": "Here is Fifty."
  },
  {
    "wordId": 5,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Hundra",
    "english": "Hundred",
    "pronunciation": "Hun-drah",
    "sentence": "Här är Hundra.",
    "sentenceTranslation": "Here is Hundred."
  },
  {
    "wordId": 6,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Tusen",
    "english": "Thousand",
    "pronunciation": "Too-sen",
    "sentence": "Här är Tusen.",
    "sentenceTranslation": "Here is Thousand."
  },
  {
    "wordId": 7,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Miljon",
    "english": "Million",
    "pronunciation": "Mil-yoon",
    "sentence": "Här är Miljon.",
    "sentenceTranslation": "Here is Million."
  },
  {
    "wordId": 8,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Halv",
    "english": "Half",
    "pronunciation": "Halv",
    "sentence": "Här är Halv.",
    "sentenceTranslation": "Here is Half."
  },
  {
    "wordId": 9,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Kvart",
    "english": "Quarter",
    "pronunciation": "Kvart",
    "sentence": "Här är Kvart.",
    "sentenceTranslation": "Here is Quarter."
  },
  {
    "wordId": 10,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Mindre",
    "english": "Less",
    "pronunciation": "Min-dreh",
    "sentence": "Här är Mindre.",
    "sentenceTranslation": "Here is Less."
  },
  {
    "wordId": 11,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Mer",
    "english": "More",
    "pronunciation": "Mehr",
    "sentence": "Här är Mer.",
    "sentenceTranslation": "Here is More."
  },
  {
    "wordId": 12,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Flest",
    "english": "Most",
    "pronunciation": "Flest",
    "sentence": "Här är Flest.",
    "sentenceTranslation": "Here is Most."
  },
  {
    "wordId": 13,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Minst",
    "english": "Least",
    "pronunciation": "Minst",
    "sentence": "Här är Minst.",
    "sentenceTranslation": "Here is Least."
  },
  {
    "wordId": 14,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Nummer",
    "english": "Number",
    "pronunciation": "Num-mer",
    "sentence": "Här är Nummer.",
    "sentenceTranslation": "Here is Number."
  },
  {
    "wordId": 15,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Räknar",
    "english": "Count",
    "pronunciation": "Rayk-nar",
    "sentence": "Här är Räknar.",
    "sentenceTranslation": "Here is Count."
  },
  {
    "wordId": 16,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Plus",
    "english": "Plus",
    "pronunciation": "Plus",
    "sentence": "Här är Plus.",
    "sentenceTranslation": "Here is Plus."
  },
  {
    "wordId": 17,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Minus",
    "english": "Minus",
    "pronunciation": "Mee-nus",
    "sentence": "Här är Minus.",
    "sentenceTranslation": "Here is Minus."
  },
  {
    "wordId": 18,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Delar",
    "english": "Share/Split",
    "pronunciation": "Deh-lar",
    "sentence": "Här är Delar.",
    "sentenceTranslation": "Here is Share/Split."
  },
  {
    "wordId": 19,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Ungefär",
    "english": "Approximately",
    "pronunciation": "Un-geh-fair",
    "sentence": "Här är Ungefär.",
    "sentenceTranslation": "Here is Approximately."
  },
  {
    "wordId": 20,
    "setId": 26,
    "setName": "26. Numbers & Math",
    "swedish": "Exakt",
    "english": "Exactly",
    "pronunciation": "Ex-akt",
    "sentence": "Här är Exakt.",
    "sentenceTranslation": "Here is Exactly."
  },
  {
    "wordId": 1,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Snäll",
    "english": "Kind",
    "pronunciation": "Snell",
    "sentence": "Här är Snäll.",
    "sentenceTranslation": "Here is Kind."
  },
  {
    "wordId": 2,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Elak",
    "english": "Mean",
    "pronunciation": "Eh-lak",
    "sentence": "Här är Elak.",
    "sentenceTranslation": "Here is Mean."
  },
  {
    "wordId": 3,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Smart",
    "english": "Smart",
    "pronunciation": "Smart",
    "sentence": "Här är Smart.",
    "sentenceTranslation": "Here is Smart."
  },
  {
    "wordId": 4,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Dum",
    "english": "Stupid",
    "pronunciation": "Dum",
    "sentence": "Här är Dum.",
    "sentenceTranslation": "Here is Stupid."
  },
  {
    "wordId": 5,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Modig",
    "english": "Brave",
    "pronunciation": "Moo-dig",
    "sentence": "Här är Modig.",
    "sentenceTranslation": "Here is Brave."
  },
  {
    "wordId": 6,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Feg",
    "english": "Cowardly",
    "pronunciation": "Fehg",
    "sentence": "Här är Feg.",
    "sentenceTranslation": "Here is Cowardly."
  },
  {
    "wordId": 7,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Lat",
    "english": "Lazy",
    "pronunciation": "Laat",
    "sentence": "Här är Lat.",
    "sentenceTranslation": "Here is Lazy."
  },
  {
    "wordId": 8,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Flitig",
    "english": "Diligent",
    "pronunciation": "Flee-tig",
    "sentence": "Här är Flitig.",
    "sentenceTranslation": "Here is Diligent."
  },
  {
    "wordId": 9,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Ärlig",
    "english": "Honest",
    "pronunciation": "Air-lig",
    "sentence": "Här är Ärlig.",
    "sentenceTranslation": "Here is Honest."
  },
  {
    "wordId": 10,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Tyst",
    "english": "Quiet",
    "pronunciation": "Tyst",
    "sentence": "Här är Tyst.",
    "sentenceTranslation": "Here is Quiet."
  },
  {
    "wordId": 11,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Högjudd",
    "english": "Loud",
    "pronunciation": "Huhg-yud",
    "sentence": "Här är Högjudd.",
    "sentenceTranslation": "Here is Loud."
  },
  {
    "wordId": 12,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Vänlig",
    "english": "Friendly",
    "pronunciation": "Ven-lig",
    "sentence": "Här är Vänlig.",
    "sentenceTranslation": "Here is Friendly."
  },
  {
    "wordId": 13,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Stolt",
    "english": "Proud",
    "pronunciation": "Stolt",
    "sentence": "Här är Stolt.",
    "sentenceTranslation": "Here is Proud."
  },
  {
    "wordId": 14,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Avundsjuk",
    "english": "Jealous",
    "pronunciation": "Ah-vund-shook",
    "sentence": "Här är Avundsjuk.",
    "sentenceTranslation": "Here is Jealous."
  },
  {
    "wordId": 15,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Nyfiken",
    "english": "Curious",
    "pronunciation": "Ny-fee-ken",
    "sentence": "Här är Nyfiken.",
    "sentenceTranslation": "Here is Curious."
  },
  {
    "wordId": 16,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Artig",
    "english": "Polite",
    "pronunciation": "Ar-tig",
    "sentence": "Här är Artig.",
    "sentenceTranslation": "Here is Polite."
  },
  {
    "wordId": 17,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Oartig",
    "english": "Rude",
    "pronunciation": "Oo-ar-tig",
    "sentence": "Här är Oartig.",
    "sentenceTranslation": "Here is Rude."
  },
  {
    "wordId": 18,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Säker",
    "english": "Sure/Safe",
    "pronunciation": "Say-ker",
    "sentence": "Här är Säker.",
    "sentenceTranslation": "Here is Sure/Safe."
  },
  {
    "wordId": 19,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Osäker",
    "english": "Unsure",
    "pronunciation": "Oo-say-ker",
    "sentence": "Här är Osäker.",
    "sentenceTranslation": "Here is Unsure."
  },
  {
    "wordId": 20,
    "setId": 27,
    "setName": "27. Personality",
    "swedish": "Känd",
    "english": "Famous",
    "pronunciation": "Shend",
    "sentence": "Här är Känd.",
    "sentenceTranslation": "Here is Famous."
  },
  {
    "wordId": 1,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Gaffel",
    "english": "Fork",
    "pronunciation": "Gaf-fel",
    "sentence": "Här är Gaffel.",
    "sentenceTranslation": "Here is Fork."
  },
  {
    "wordId": 2,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Kniv",
    "english": "Knife",
    "pronunciation": "Kneev",
    "sentence": "Här är Kniv.",
    "sentenceTranslation": "Here is Knife."
  },
  {
    "wordId": 3,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Sked",
    "english": "Spoon",
    "pronunciation": "Skehd",
    "sentence": "Här är Sked.",
    "sentenceTranslation": "Here is Spoon."
  },
  {
    "wordId": 4,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Kopp",
    "english": "Cup",
    "pronunciation": "Kop",
    "sentence": "Här är Kopp.",
    "sentenceTranslation": "Here is Cup."
  },
  {
    "wordId": 5,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Skål",
    "english": "Bowl",
    "pronunciation": "Skohl",
    "sentence": "Här är Skål.",
    "sentenceTranslation": "Here is Bowl."
  },
  {
    "wordId": 6,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Kastrull",
    "english": "Pot",
    "pronunciation": "Kas-trull",
    "sentence": "Här är Kastrull.",
    "sentenceTranslation": "Here is Pot."
  },
  {
    "wordId": 7,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Stekpanna",
    "english": "Frying pan",
    "pronunciation": "Stehk-pan-nah",
    "sentence": "Här är Stekpanna.",
    "sentenceTranslation": "Here is Frying pan."
  },
  {
    "wordId": 8,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Handduk",
    "english": "Towel",
    "pronunciation": "Hand-dook",
    "sentence": "Här är Handduk.",
    "sentenceTranslation": "Here is Towel."
  },
  {
    "wordId": 9,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Tvål",
    "english": "Soap",
    "pronunciation": "Tvohl",
    "sentence": "Här är Tvål.",
    "sentenceTranslation": "Here is Soap."
  },
  {
    "wordId": 10,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Schampo",
    "english": "Shampoo",
    "pronunciation": "Sham-poo",
    "sentence": "Här är Schampo.",
    "sentenceTranslation": "Here is Shampoo."
  },
  {
    "wordId": 11,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Tandborste",
    "english": "Toothbrush",
    "pronunciation": "Tand-bor-steh",
    "sentence": "Här är Tandborste.",
    "sentenceTranslation": "Here is Toothbrush."
  },
  {
    "wordId": 12,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Spegel",
    "english": "Mirror",
    "pronunciation": "Speh-gel",
    "sentence": "Här är Spegel.",
    "sentenceTranslation": "Here is Mirror."
  },
  {
    "wordId": 13,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Täcke",
    "english": "Duvet",
    "pronunciation": "Tek-keh",
    "sentence": "Här är Täcke.",
    "sentenceTranslation": "Here is Duvet."
  },
  {
    "wordId": 14,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Kudde",
    "english": "Pillow",
    "pronunciation": "Kud-deh",
    "sentence": "Här är Kudde.",
    "sentenceTranslation": "Here is Pillow."
  },
  {
    "wordId": 15,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Lakan",
    "english": "Sheet",
    "pronunciation": "Lah-kan",
    "sentence": "Här är Lakan.",
    "sentenceTranslation": "Here is Sheet."
  },
  {
    "wordId": 16,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Matta",
    "english": "Rug",
    "pronunciation": "Mat-tah",
    "sentence": "Här är Matta.",
    "sentenceTranslation": "Here is Rug."
  },
  {
    "wordId": 17,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Gardin",
    "english": "Curtain",
    "pronunciation": "Gar-deen",
    "sentence": "Här är Gardin.",
    "sentenceTranslation": "Here is Curtain."
  },
  {
    "wordId": 18,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Kylskåp",
    "english": "Fridge",
    "pronunciation": "Shyl-skohp",
    "sentence": "Här är Kylskåp.",
    "sentenceTranslation": "Here is Fridge."
  },
  {
    "wordId": 19,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Frys",
    "english": "Freezer",
    "pronunciation": "Frees",
    "sentence": "Här är Frys.",
    "sentenceTranslation": "Here is Freezer."
  },
  {
    "wordId": 20,
    "setId": 28,
    "setName": "28. Household",
    "swedish": "Ugn",
    "english": "Oven",
    "pronunciation": "Ungn",
    "sentence": "Här är Ugn.",
    "sentenceTranslation": "Here is Oven."
  },
  {
    "wordId": 1,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Inga problem",
    "english": "No problem",
    "pronunciation": "Ing-ah prob-lem",
    "sentence": "Här är Inga problem.",
    "sentenceTranslation": "Here is No problem."
  },
  {
    "wordId": 2,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Vad kul",
    "english": "How fun",
    "pronunciation": "Vad kool",
    "sentence": "Här är Vad kul.",
    "sentenceTranslation": "Here is How fun."
  },
  {
    "wordId": 3,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Lycka till",
    "english": "Good luck",
    "pronunciation": "Lyk-kah till",
    "sentence": "Här är Lycka till.",
    "sentenceTranslation": "Here is Good luck."
  },
  {
    "wordId": 4,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Trevlig helg",
    "english": "Have a nice weekend",
    "pronunciation": "Trev-lig helg",
    "sentence": "Här är Trevlig helg.",
    "sentenceTranslation": "Here is Have a nice weekend."
  },
  {
    "wordId": 5,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Krya på dig",
    "english": "Get well soon",
    "pronunciation": "Kry-ah poh day",
    "sentence": "Här är Krya på dig.",
    "sentenceTranslation": "Here is Get well soon."
  },
  {
    "wordId": 6,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Skål",
    "english": "Cheers",
    "pronunciation": "Skohl",
    "sentence": "Här är Skål.",
    "sentenceTranslation": "Here is Cheers."
  },
  {
    "wordId": 7,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Smaklig måltid",
    "english": "Bon appetit",
    "pronunciation": "Smak-lig mohl-tid",
    "sentence": "Här är Smaklig måltid.",
    "sentenceTranslation": "Here is Bon appetit."
  },
  {
    "wordId": 8,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Ta det lugnt",
    "english": "Take it easy",
    "pronunciation": "Ta deh lugnt",
    "sentence": "Här är Ta det lugnt.",
    "sentenceTranslation": "Here is Take it easy."
  },
  {
    "wordId": 9,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Jag vet inte",
    "english": "I don't know",
    "pronunciation": "Ja veht in-teh",
    "sentence": "Här är Jag vet inte.",
    "sentenceTranslation": "Here is I don't know."
  },
  {
    "wordId": 10,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Jag tror det",
    "english": "I think so",
    "pronunciation": "Ja troor deh",
    "sentence": "Här är Jag tror det.",
    "sentenceTranslation": "Here is I think so."
  },
  {
    "wordId": 11,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Det spelar ingen roll",
    "english": "It doesn't matter",
    "pronunciation": "Deh speh-lar ing-en roll",
    "sentence": "Här är Det spelar ingen roll.",
    "sentenceTranslation": "Here is It doesn't matter."
  },
  {
    "wordId": 12,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Ursäkta mig",
    "english": "Excuse me",
    "pronunciation": "Ur-shek-ta may",
    "sentence": "Här är Ursäkta mig.",
    "sentenceTranslation": "Here is Excuse me."
  },
  {
    "wordId": 13,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Vänta lite",
    "english": "Wait a bit",
    "pronunciation": "Ven-ta lee-teh",
    "sentence": "Här är Vänta lite.",
    "sentenceTranslation": "Here is Wait a bit."
  },
  {
    "wordId": 14,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Kom in",
    "english": "Come in",
    "pronunciation": "Kom in",
    "sentence": "Här är Kom in.",
    "sentenceTranslation": "Here is Come in."
  },
  {
    "wordId": 15,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Varsågod",
    "english": "Here you go",
    "pronunciation": "Var-so-good",
    "sentence": "Här är Varsågod.",
    "sentenceTranslation": "Here is Here you go."
  },
  {
    "wordId": 16,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Vi ses",
    "english": "See you",
    "pronunciation": "Vi sehs",
    "sentence": "Här är Vi ses.",
    "sentenceTranslation": "Here is See you."
  },
  {
    "wordId": 17,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Ha det bra",
    "english": "Take care",
    "pronunciation": "Ha deh bra",
    "sentence": "Här är Ha det bra.",
    "sentenceTranslation": "Here is Take care."
  },
  {
    "wordId": 18,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Samma här",
    "english": "Same here",
    "pronunciation": "Sam-ma hair",
    "sentence": "Här är Samma här.",
    "sentenceTranslation": "Here is Same here."
  },
  {
    "wordId": 19,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Vad gör du?",
    "english": "What are you doing?",
    "pronunciation": "Vad yur doo",
    "sentence": "Här är Vad gör du?.",
    "sentenceTranslation": "Here is What are you doing?."
  },
  {
    "wordId": 20,
    "setId": 29,
    "setName": "29. Common Phrases",
    "swedish": "Hur är läget?",
    "english": "What's up?",
    "pronunciation": "Hur air lay-get",
    "sentence": "Här är Hur är läget?.",
    "sentenceTranslation": "Here is What's up?."
  },
  {
    "wordId": 1,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Idé",
    "english": "Idea",
    "pronunciation": "Ee-deh",
    "sentence": "Här är Idé.",
    "sentenceTranslation": "Here is Idea."
  },
  {
    "wordId": 2,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Problem",
    "english": "Problem",
    "pronunciation": "Prob-lem",
    "sentence": "Här är Problem.",
    "sentenceTranslation": "Here is Problem."
  },
  {
    "wordId": 3,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Lösning",
    "english": "Solution",
    "pronunciation": "Luhs-ning",
    "sentence": "Här är Lösning.",
    "sentenceTranslation": "Here is Solution."
  },
  {
    "wordId": 4,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Resultat",
    "english": "Result",
    "pronunciation": "Re-sul-taat",
    "sentence": "Här är Resultat.",
    "sentenceTranslation": "Here is Result."
  },
  {
    "wordId": 5,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Möjlighet",
    "english": "Possibility",
    "pronunciation": "Moy-lig-het",
    "sentence": "Här är Möjlighet.",
    "sentenceTranslation": "Here is Possibility."
  },
  {
    "wordId": 6,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Sanning",
    "english": "Truth",
    "pronunciation": "San-ning",
    "sentence": "Här är Sanning.",
    "sentenceTranslation": "Here is Truth."
  },
  {
    "wordId": 7,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Lögn",
    "english": "Lie",
    "pronunciation": "Luhgn",
    "sentence": "Här är Lögn.",
    "sentenceTranslation": "Here is Lie."
  },
  {
    "wordId": 8,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Fred",
    "english": "Peace",
    "pronunciation": "Frehd",
    "sentence": "Här är Fred.",
    "sentenceTranslation": "Here is Peace."
  },
  {
    "wordId": 9,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Krig",
    "english": "War",
    "pronunciation": "Kreeg",
    "sentence": "Här är Krig.",
    "sentenceTranslation": "Here is War."
  },
  {
    "wordId": 10,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Frihet",
    "english": "Freedom",
    "pronunciation": "Free-het",
    "sentence": "Här är Frihet.",
    "sentenceTranslation": "Here is Freedom."
  },
  {
    "wordId": 11,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Kärlek",
    "english": "Love",
    "pronunciation": "Shair-lehk",
    "sentence": "Här är Kärlek.",
    "sentenceTranslation": "Here is Love."
  },
  {
    "wordId": 12,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Hat",
    "english": "Hate",
    "pronunciation": "Haat",
    "sentence": "Här är Hat.",
    "sentenceTranslation": "Here is Hate."
  },
  {
    "wordId": 13,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Dröm",
    "english": "Dream",
    "pronunciation": "Drum",
    "sentence": "Här är Dröm.",
    "sentenceTranslation": "Here is Dream."
  },
  {
    "wordId": 14,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Tanke",
    "english": "Thought",
    "pronunciation": "Tan-keh",
    "sentence": "Här är Tanke.",
    "sentenceTranslation": "Here is Thought."
  },
  {
    "wordId": 15,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Känsla",
    "english": "Feeling",
    "pronunciation": "Shen-slah",
    "sentence": "Här är Känsla.",
    "sentenceTranslation": "Here is Feeling."
  },
  {
    "wordId": 16,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Kunskap",
    "english": "Knowledge",
    "pronunciation": "Kun-skap",
    "sentence": "Här är Kunskap.",
    "sentenceTranslation": "Here is Knowledge."
  },
  {
    "wordId": 17,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Makt",
    "english": "Power",
    "pronunciation": "Makt",
    "sentence": "Här är Makt.",
    "sentenceTranslation": "Here is Power."
  },
  {
    "wordId": 18,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Regel",
    "english": "Rule",
    "pronunciation": "Reh-gel",
    "sentence": "Här är Regel.",
    "sentenceTranslation": "Here is Rule."
  },
  {
    "wordId": 19,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Exempel",
    "english": "Example",
    "pronunciation": "Ex-em-pel",
    "sentence": "Här är Exempel.",
    "sentenceTranslation": "Here is Example."
  },
  {
    "wordId": 20,
    "setId": 30,
    "setName": "30. Abstract",
    "swedish": "Orsak",
    "english": "Reason/Cause",
    "pronunciation": "Oor-saak",
    "sentence": "Här är Orsak.",
    "sentenceTranslation": "Here is Reason/Cause."
  },
  {
    "wordId": 1,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Vad heter du?",
    "english": "What is your name?",
    "pronunciation": "Vad hee-ter doo",
    "sentence": "Här är Vad heter du?.",
    "sentenceTranslation": "Here is What is your name?."
  },
  {
    "wordId": 2,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Jag heter...",
    "english": "My name is...",
    "pronunciation": "Ya hee-ter",
    "sentence": "Här är Jag heter....",
    "sentenceTranslation": "Here is My name is...."
  },
  {
    "wordId": 3,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Var bor du?",
    "english": "Where do you live?",
    "pronunciation": "Var boor doo",
    "sentence": "Här är Var bor du?.",
    "sentenceTranslation": "Here is Where do you live?."
  },
  {
    "wordId": 4,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Jag bor i...",
    "english": "I live in...",
    "pronunciation": "Ya boor ee",
    "sentence": "Här är Jag bor i....",
    "sentenceTranslation": "Here is I live in...."
  },
  {
    "wordId": 5,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Var kommer du ifrån?",
    "english": "Where are you from?",
    "pronunciation": "Var kom-mer doo ee-frohn",
    "sentence": "Här är Var kommer du ifrån?.",
    "sentenceTranslation": "Here is Where are you from?."
  },
  {
    "wordId": 6,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Jag kommer från...",
    "english": "I come from...",
    "pronunciation": "Ya kom-mer frohn",
    "sentence": "Här är Jag kommer från....",
    "sentenceTranslation": "Here is I come from...."
  },
  {
    "wordId": 7,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Trevligt att träffas",
    "english": "Nice to meet you",
    "pronunciation": "Trev-ligt at tref-fas",
    "sentence": "Här är Trevligt att träffas.",
    "sentenceTranslation": "Here is Nice to meet you."
  },
  {
    "wordId": 8,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Hur gammal är du?",
    "english": "How old are you?",
    "pronunciation": "Hur gam-mal air doo",
    "sentence": "Här är Hur gammal är du?.",
    "sentenceTranslation": "Here is How old are you?."
  },
  {
    "wordId": 9,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Jag är tjugo år",
    "english": "I am twenty years old",
    "pronunciation": "Ya air shoo-go ohr",
    "sentence": "Här är Jag är tjugo år.",
    "sentenceTranslation": "Here is I am twenty years old."
  },
  {
    "wordId": 10,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Vad jobbar du med?",
    "english": "What do you do? (work)",
    "pronunciation": "Vad yob-bar doo mehd",
    "sentence": "Här är Vad jobbar du med?.",
    "sentenceTranslation": "Here is What do you do? (work)."
  },
  {
    "wordId": 11,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Jag är student",
    "english": "I am a student",
    "pronunciation": "Ya air stoo-dent",
    "sentence": "Här är Jag är student.",
    "sentenceTranslation": "Here is I am a student."
  },
  {
    "wordId": 12,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Jag gillar Sverige",
    "english": "I like Sweden",
    "pronunciation": "Ya gil-lar Sveh-ryeh",
    "sentence": "Här är Jag gillar Sverige.",
    "sentenceTranslation": "Here is I like Sweden."
  },
  {
    "wordId": 13,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Talar du engelska?",
    "english": "Do you speak English?",
    "pronunciation": "Tah-lar doo eng-el-ska",
    "sentence": "Här är Talar du engelska?.",
    "sentenceTranslation": "Here is Do you speak English?."
  },
  {
    "wordId": 14,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Jag talar lite svenska",
    "english": "I speak a little Swedish",
    "pronunciation": "Ya tah-lar lee-teh sven-ska",
    "sentence": "Här är Jag talar lite svenska.",
    "sentenceTranslation": "Here is I speak a little Swedish."
  },
  {
    "wordId": 15,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Jag förstår inte",
    "english": "I don't understand",
    "pronunciation": "Ya fur-stohr in-teh",
    "sentence": "Här är Jag förstår inte.",
    "sentenceTranslation": "Here is I don't understand."
  },
  {
    "wordId": 16,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Förstår du?",
    "english": "Do you understand?",
    "pronunciation": "Fur-stohr doo",
    "sentence": "Här är Förstår du?.",
    "sentenceTranslation": "Here is Do you understand?."
  },
  {
    "wordId": 17,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Kan du upprepa?",
    "english": "Can you repeat?",
    "pronunciation": "Kan doo up-reh-pa",
    "sentence": "Här är Kan du upprepa?.",
    "sentenceTranslation": "Here is Can you repeat?."
  },
  {
    "wordId": 18,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Prata långsammare",
    "english": "Speak slower",
    "pronunciation": "Prah-ta long-sam-ma-reh",
    "sentence": "Här är Prata långsammare.",
    "sentenceTranslation": "Here is Speak slower."
  },
  {
    "wordId": 19,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Vad sa du?",
    "english": "What did you say?",
    "pronunciation": "Vad sah doo",
    "sentence": "Här är Vad sa du?.",
    "sentenceTranslation": "Here is What did you say?."
  },
  {
    "wordId": 20,
    "setId": 31,
    "setName": "31. Introductions",
    "swedish": "Det är okej",
    "english": "It is okay",
    "pronunciation": "Deh air o-kay",
    "sentence": "Här är Det är okej.",
    "sentenceTranslation": "Here is It is okay."
  },
  {
    "wordId": 1,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Jag är hungrig",
    "english": "I am hungry",
    "pronunciation": "Ya air hung-rig",
    "sentence": "Här är Jag är hungrig.",
    "sentenceTranslation": "Here is I am hungry."
  },
  {
    "wordId": 2,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Jag är törstig",
    "english": "I am thirsty",
    "pronunciation": "Ya air tur-stig",
    "sentence": "Här är Jag är törstig.",
    "sentenceTranslation": "Here is I am thirsty."
  },
  {
    "wordId": 3,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Har ni ett bord?",
    "english": "Do you have a table?",
    "pronunciation": "Har nee et boord",
    "sentence": "Här är Har ni ett bord?.",
    "sentenceTranslation": "Here is Do you have a table?."
  },
  {
    "wordId": 4,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Menyn, tack",
    "english": "The menu, please",
    "pronunciation": "Me-nyn tak",
    "sentence": "Här är Menyn, tack.",
    "sentenceTranslation": "Here is The menu, please."
  },
  {
    "wordId": 5,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Jag vill ha...",
    "english": "I want...",
    "pronunciation": "Ya vill ha",
    "sentence": "Här är Jag vill ha....",
    "sentenceTranslation": "Here is I want...."
  },
  {
    "wordId": 6,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Kan jag få...",
    "english": "Can I get...",
    "pronunciation": "Kan ya foh",
    "sentence": "Här är Kan jag få....",
    "sentenceTranslation": "Here is Can I get...."
  },
  {
    "wordId": 7,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "En kaffe, tack",
    "english": "A coffee, please",
    "pronunciation": "En kaf-feh tak",
    "sentence": "Här är En kaffe, tack.",
    "sentenceTranslation": "Here is A coffee, please."
  },
  {
    "wordId": 8,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "En öl, tack",
    "english": "A beer, please",
    "pronunciation": "En uhl tak",
    "sentence": "Här är En öl, tack.",
    "sentenceTranslation": "Here is A beer, please."
  },
  {
    "wordId": 9,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Vatten, tack",
    "english": "Water, please",
    "pronunciation": "Vat-ten tak",
    "sentence": "Här är Vatten, tack.",
    "sentenceTranslation": "Here is Water, please."
  },
  {
    "wordId": 10,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Vad kostar det?",
    "english": "How much is it?",
    "pronunciation": "Vad kos-tar deh",
    "sentence": "Här är Vad kostar det?.",
    "sentenceTranslation": "Here is How much is it?."
  },
  {
    "wordId": 11,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Det är gott",
    "english": "It is good (tasty)",
    "pronunciation": "Deh air gott",
    "sentence": "Här är Det är gott.",
    "sentenceTranslation": "Here is It is good (tasty)."
  },
  {
    "wordId": 12,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Jag är mätt",
    "english": "I am full",
    "pronunciation": "Ya air mett",
    "sentence": "Här är Jag är mätt.",
    "sentenceTranslation": "Here is I am full."
  },
  {
    "wordId": 13,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Notan, tack",
    "english": "The bill, please",
    "pronunciation": "No-tan tak",
    "sentence": "Här är Notan, tack.",
    "sentenceTranslation": "Here is The bill, please."
  },
  {
    "wordId": 14,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Kan jag betala?",
    "english": "Can I pay?",
    "pronunciation": "Kan ya be-tah-lah",
    "sentence": "Här är Kan jag betala?.",
    "sentenceTranslation": "Here is Can I pay?."
  },
  {
    "wordId": 15,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Med kort",
    "english": "With card",
    "pronunciation": "Mehd koort",
    "sentence": "Här är Med kort.",
    "sentenceTranslation": "Here is With card."
  },
  {
    "wordId": 16,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Kontant",
    "english": "Cash",
    "pronunciation": "Kon-tant",
    "sentence": "Här är Kontant.",
    "sentenceTranslation": "Here is Cash."
  },
  {
    "wordId": 17,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Var är toaletten?",
    "english": "Where is the toilet?",
    "pronunciation": "Var air to-a-let-ten",
    "sentence": "Här är Var är toaletten?.",
    "sentenceTranslation": "Here is Where is the toilet?."
  },
  {
    "wordId": 18,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Smaklig måltid",
    "english": "Enjoy your meal",
    "pronunciation": "Smak-lig mohl-tid",
    "sentence": "Här är Smaklig måltid.",
    "sentenceTranslation": "Here is Enjoy your meal."
  },
  {
    "wordId": 19,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "En till, tack",
    "english": "One more, please",
    "pronunciation": "En till tak",
    "sentence": "Här är En till, tack.",
    "sentenceTranslation": "Here is One more, please."
  },
  {
    "wordId": 20,
    "setId": 32,
    "setName": "32. Ordering",
    "swedish": "Det var allt",
    "english": "That was all",
    "pronunciation": "Deh var allt",
    "sentence": "Här är Det var allt.",
    "sentenceTranslation": "Here is That was all."
  },
  {
    "wordId": 1,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Ursäkta mig",
    "english": "Excuse me",
    "pronunciation": "Ur-shek-ta may",
    "sentence": "Här är Ursäkta mig.",
    "sentenceTranslation": "Here is Excuse me."
  },
  {
    "wordId": 2,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Jag letar efter...",
    "english": "I am looking for...",
    "pronunciation": "Ya leh-tar ef-ter",
    "sentence": "Här är Jag letar efter....",
    "sentenceTranslation": "Here is I am looking for...."
  },
  {
    "wordId": 3,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Var är stationen?",
    "english": "Where is the station?",
    "pronunciation": "Var air sta-sho-nen",
    "sentence": "Här är Var är stationen?.",
    "sentenceTranslation": "Here is Where is the station?."
  },
  {
    "wordId": 4,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Var är hotellet?",
    "english": "Where is the hotel?",
    "pronunciation": "Var air ho-tel-let",
    "sentence": "Här är Var är hotellet?.",
    "sentenceTranslation": "Here is Where is the hotel?."
  },
  {
    "wordId": 5,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Gå rakt fram",
    "english": "Go straight ahead",
    "pronunciation": "Goh rakt fram",
    "sentence": "Här är Gå rakt fram.",
    "sentenceTranslation": "Here is Go straight ahead."
  },
  {
    "wordId": 6,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Sväng höger",
    "english": "Turn right",
    "pronunciation": "Sveng huh-ger",
    "sentence": "Här är Sväng höger.",
    "sentenceTranslation": "Here is Turn right."
  },
  {
    "wordId": 7,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Sväng vänster",
    "english": "Turn left",
    "pronunciation": "Sveng ven-ster",
    "sentence": "Här är Sväng vänster.",
    "sentenceTranslation": "Here is Turn left."
  },
  {
    "wordId": 8,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Det är nära",
    "english": "It is close",
    "pronunciation": "Deh air nai-ra",
    "sentence": "Här är Det är nära.",
    "sentenceTranslation": "Here is It is close."
  },
  {
    "wordId": 9,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Det är långt bort",
    "english": "It is far away",
    "pronunciation": "Deh air longt bort",
    "sentence": "Här är Det är långt bort.",
    "sentenceTranslation": "Here is It is far away."
  },
  {
    "wordId": 10,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Jag är vilse",
    "english": "I am lost",
    "pronunciation": "Ya air vil-seh",
    "sentence": "Här är Jag är vilse.",
    "sentenceTranslation": "Here is I am lost."
  },
  {
    "wordId": 11,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Kan du visa mig?",
    "english": "Can you show me?",
    "pronunciation": "Kan doo vee-sa may",
    "sentence": "Här är Kan du visa mig?.",
    "sentenceTranslation": "Here is Can you show me?."
  },
  {
    "wordId": 12,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "På kartan",
    "english": "On the map",
    "pronunciation": "Poh kar-tan",
    "sentence": "Här är På kartan.",
    "sentenceTranslation": "Here is On the map."
  },
  {
    "wordId": 13,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Stannar bussen här?",
    "english": "Does the bus stop here?",
    "pronunciation": "Stan-nar bus-sen hair",
    "sentence": "Här är Stannar bussen här?.",
    "sentenceTranslation": "Here is Does the bus stop here?."
  },
  {
    "wordId": 14,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "När går tåget?",
    "english": "When does the train leave?",
    "pronunciation": "Nair gohr toh-get",
    "sentence": "Här är När går tåget?.",
    "sentenceTranslation": "Here is When does the train leave?."
  },
  {
    "wordId": 15,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "En biljett, tack",
    "english": "One ticket, please",
    "pronunciation": "En bil-yett tak",
    "sentence": "Här är En biljett, tack.",
    "sentenceTranslation": "Here is One ticket, please."
  },
  {
    "wordId": 16,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Till Stockholm",
    "english": "To Stockholm",
    "pronunciation": "Till Stockholm",
    "sentence": "Här är Till Stockholm.",
    "sentenceTranslation": "Here is To Stockholm."
  },
  {
    "wordId": 17,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Vad är klockan?",
    "english": "What time is it?",
    "pronunciation": "Vad air klok-kan",
    "sentence": "Här är Vad är klockan?.",
    "sentenceTranslation": "Here is What time is it?."
  },
  {
    "wordId": 18,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Klockan är tre",
    "english": "It is three o'clock",
    "pronunciation": "Klok-kan air treh",
    "sentence": "Här är Klockan är tre.",
    "sentenceTranslation": "Here is It is three o'clock."
  },
  {
    "wordId": 19,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Vi är framme",
    "english": "We have arrived",
    "pronunciation": "Vee air fram-meh",
    "sentence": "Här är Vi är framme.",
    "sentenceTranslation": "Here is We have arrived."
  },
  {
    "wordId": 20,
    "setId": 33,
    "setName": "33. Directions",
    "swedish": "Trevlig resa",
    "english": "Have a nice trip",
    "pronunciation": "Trev-lig reh-sa",
    "sentence": "Här är Trevlig resa.",
    "sentenceTranslation": "Here is Have a nice trip."
  },
  {
    "wordId": 1,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Jag gillar det",
    "english": "I like it",
    "pronunciation": "Ya gil-lar deh",
    "sentence": "Här är Jag gillar det.",
    "sentenceTranslation": "Here is I like it."
  },
  {
    "wordId": 2,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Jag gillar det inte",
    "english": "I don't like it",
    "pronunciation": "Ya gil-lar deh in-teh",
    "sentence": "Här är Jag gillar det inte.",
    "sentenceTranslation": "Here is I don't like it."
  },
  {
    "wordId": 3,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Vad tycker du?",
    "english": "What do you think?",
    "pronunciation": "Vad tyk-ker doo",
    "sentence": "Här är Vad tycker du?.",
    "sentenceTranslation": "Here is What do you think?."
  },
  {
    "wordId": 4,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Jag tycker att...",
    "english": "I think that...",
    "pronunciation": "Ya tyk-ker at",
    "sentence": "Här är Jag tycker att....",
    "sentenceTranslation": "Here is I think that...."
  },
  {
    "wordId": 5,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Det är bra",
    "english": "It is good",
    "pronunciation": "Deh air bra",
    "sentence": "Här är Det är bra.",
    "sentenceTranslation": "Here is It is good."
  },
  {
    "wordId": 6,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Det är dåligt",
    "english": "It is bad",
    "pronunciation": "Deh air doh-ligt",
    "sentence": "Här är Det är dåligt.",
    "sentenceTranslation": "Here is It is bad."
  },
  {
    "wordId": 7,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Det är roligt",
    "english": "It is fun",
    "pronunciation": "Deh air roo-ligt",
    "sentence": "Här är Det är roligt.",
    "sentenceTranslation": "Here is It is fun."
  },
  {
    "wordId": 8,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Det är tråkigt",
    "english": "It is boring",
    "pronunciation": "Deh air troh-kigt",
    "sentence": "Här är Det är tråkigt.",
    "sentenceTranslation": "Here is It is boring."
  },
  {
    "wordId": 9,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Jag håller med",
    "english": "I agree",
    "pronunciation": "Ya hol-ler mehd",
    "sentence": "Här är Jag håller med.",
    "sentenceTranslation": "Here is I agree."
  },
  {
    "wordId": 10,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Jag vet inte",
    "english": "I don't know",
    "pronunciation": "Ya veht in-teh",
    "sentence": "Här är Jag vet inte.",
    "sentenceTranslation": "Here is I don't know."
  },
  {
    "wordId": 11,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Jag tror det",
    "english": "I think so",
    "pronunciation": "Ya troor deh",
    "sentence": "Här är Jag tror det.",
    "sentenceTranslation": "Here is I think so."
  },
  {
    "wordId": 12,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Kanske senare",
    "english": "Maybe later",
    "pronunciation": "Kan-sheh seh-na-reh",
    "sentence": "Här är Kanske senare.",
    "sentenceTranslation": "Here is Maybe later."
  },
  {
    "wordId": 13,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Jag är säker",
    "english": "I am sure",
    "pronunciation": "Ya air say-ker",
    "sentence": "Här är Jag är säker.",
    "sentenceTranslation": "Here is I am sure."
  },
  {
    "wordId": 14,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Du har rätt",
    "english": "You are right",
    "pronunciation": "Doo har rett",
    "sentence": "Här är Du har rätt.",
    "sentenceTranslation": "Here is You are right."
  },
  {
    "wordId": 15,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Det är fel",
    "english": "It is wrong",
    "pronunciation": "Deh air fehl",
    "sentence": "Här är Det är fel.",
    "sentenceTranslation": "Here is It is wrong."
  },
  {
    "wordId": 16,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Det är sant",
    "english": "It is true",
    "pronunciation": "Deh air sant",
    "sentence": "Här är Det är sant.",
    "sentenceTranslation": "Here is It is true."
  },
  {
    "wordId": 17,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Det är viktigt",
    "english": "It is important",
    "pronunciation": "Deh air vik-tigt",
    "sentence": "Här är Det är viktigt.",
    "sentenceTranslation": "Here is It is important."
  },
  {
    "wordId": 18,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Jag är trött",
    "english": "I am tired",
    "pronunciation": "Ya air trutt",
    "sentence": "Här är Jag är trött.",
    "sentenceTranslation": "Here is I am tired."
  },
  {
    "wordId": 19,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Jag är glad",
    "english": "I am happy",
    "pronunciation": "Ya air glaad",
    "sentence": "Här är Jag är glad.",
    "sentenceTranslation": "Here is I am happy."
  },
  {
    "wordId": 20,
    "setId": 34,
    "setName": "34. Opinions",
    "swedish": "Det är dyrt",
    "english": "It is expensive",
    "pronunciation": "Deh air dyrt",
    "sentence": "Här är Det är dyrt.",
    "sentenceTranslation": "Here is It is expensive."
  },
  {
    "wordId": 1,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Vad gör du?",
    "english": "What are you doing?",
    "pronunciation": "Vad yur doo",
    "sentence": "Här är Vad gör du?.",
    "sentenceTranslation": "Here is What are you doing?."
  },
  {
    "wordId": 2,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Jag läser",
    "english": "I am reading",
    "pronunciation": "Ya lay-ser",
    "sentence": "Här är Jag läser.",
    "sentenceTranslation": "Here is I am reading."
  },
  {
    "wordId": 3,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Jag äter",
    "english": "I am eating",
    "pronunciation": "Ya eh-ter",
    "sentence": "Här är Jag äter.",
    "sentenceTranslation": "Here is I am eating."
  },
  {
    "wordId": 4,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Jag arbetar",
    "english": "I am working",
    "pronunciation": "Ya ar-beh-tar",
    "sentence": "Här är Jag arbetar.",
    "sentenceTranslation": "Here is I am working."
  },
  {
    "wordId": 5,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Jag måste gå",
    "english": "I have to go",
    "pronunciation": "Ya mos-teh goh",
    "sentence": "Här är Jag måste gå.",
    "sentenceTranslation": "Here is I have to go."
  },
  {
    "wordId": 6,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Vart ska du?",
    "english": "Where are you going?",
    "pronunciation": "Vart ska doo",
    "sentence": "Här är Vart ska du?.",
    "sentenceTranslation": "Here is Where are you going?."
  },
  {
    "wordId": 7,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Jag ska hem",
    "english": "I am going home",
    "pronunciation": "Ya ska hem",
    "sentence": "Här är Jag ska hem.",
    "sentenceTranslation": "Here is I am going home."
  },
  {
    "wordId": 8,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Vad ska vi göra?",
    "english": "What shall we do?",
    "pronunciation": "Vad ska vee yur-ah",
    "sentence": "Här är Vad ska vi göra?.",
    "sentenceTranslation": "Here is What shall we do?."
  },
  {
    "wordId": 9,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Vill du följa med?",
    "english": "Do you want to come?",
    "pronunciation": "Vill doo ful-ya mehd",
    "sentence": "Här är Vill du följa med?.",
    "sentenceTranslation": "Here is Do you want to come?."
  },
  {
    "wordId": 10,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Vi ses imorgon",
    "english": "See you tomorrow",
    "pronunciation": "Vee sehs ee-mor-ron",
    "sentence": "Här är Vi ses imorgon.",
    "sentenceTranslation": "Here is See you tomorrow."
  },
  {
    "wordId": 11,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Ring mig",
    "english": "Call me",
    "pronunciation": "Ring may",
    "sentence": "Här är Ring mig.",
    "sentenceTranslation": "Here is Call me."
  },
  {
    "wordId": 12,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Skriv till mig",
    "english": "Write to me",
    "pronunciation": "Skreev till may",
    "sentence": "Här är Skriv till mig.",
    "sentenceTranslation": "Here is Write to me."
  },
  {
    "wordId": 13,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Jag älskar dig",
    "english": "I love you",
    "pronunciation": "Ya el-skar day",
    "sentence": "Här är Jag älskar dig.",
    "sentenceTranslation": "Here is I love you."
  },
  {
    "wordId": 14,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Jag saknar dig",
    "english": "I miss you",
    "pronunciation": "Ya sak-nar day",
    "sentence": "Här är Jag saknar dig.",
    "sentenceTranslation": "Here is I miss you."
  },
  {
    "wordId": 15,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Kom hit",
    "english": "Come here",
    "pronunciation": "Kom heet",
    "sentence": "Här är Kom hit.",
    "sentenceTranslation": "Here is Come here."
  },
  {
    "wordId": 16,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Titta på detta",
    "english": "Look at this",
    "pronunciation": "Tit-ta poh det-ta",
    "sentence": "Här är Titta på detta.",
    "sentenceTranslation": "Here is Look at this."
  },
  {
    "wordId": 17,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Lyssna på mig",
    "english": "Listen to me",
    "pronunciation": "Lys-na poh may",
    "sentence": "Här är Lyssna på mig.",
    "sentenceTranslation": "Here is Listen to me."
  },
  {
    "wordId": 18,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Vänta på mig",
    "english": "Wait for me",
    "pronunciation": "Ven-ta poh may",
    "sentence": "Här är Vänta på mig.",
    "sentenceTranslation": "Here is Wait for me."
  },
  {
    "wordId": 19,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Jag är klar",
    "english": "I am done/ready",
    "pronunciation": "Ya air klar",
    "sentence": "Här är Jag är klar.",
    "sentenceTranslation": "Here is I am done/ready."
  },
  {
    "wordId": 20,
    "setId": 35,
    "setName": "35. Actions",
    "swedish": "Nu går vi",
    "english": "Let's go now",
    "pronunciation": "Noo gohr vee",
    "sentence": "Här är Nu går vi.",
    "sentenceTranslation": "Here is Let's go now."
  }
];
